/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/v2.0/plugins/trademark/static/assets/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 22);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = normalizeComponent;
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_7_1_5_babel_loader_lib_index_js_node_modules_vue_loader_15_9_1_vue_loader_lib_index_js_vue_loader_options_App_vue_vue_type_script_lang_js___ = __webpack_require__(2);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_7_1_5_babel_loader_lib_index_js_node_modules_vue_loader_15_9_1_vue_loader_lib_index_js_vue_loader_options_App_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),
/* 3 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_7_1_5_babel_loader_lib_index_js_node_modules_vue_loader_15_9_1_vue_loader_lib_index_js_vue_loader_options_trademark_vue_vue_type_script_lang_js___ = __webpack_require__(5);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_7_1_5_babel_loader_lib_index_js_node_modules_vue_loader_15_9_1_vue_loader_lib_index_js_vue_loader_options_trademark_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_components_new_header_trademark__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__static_assets_zjfd_icon_png__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__static_assets_zjfd_icon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__static_assets_zjfd_icon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_assets_dbzc_icon_png__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_assets_dbzc_icon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__static_assets_dbzc_icon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_assets_sbxz_icon_png__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_assets_sbxz_icon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__static_assets_sbxz_icon_png__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      activeName: 'first',
      domainSuffixs: [],
      serverAdvantageList: [{
        title: '注册评估低风险',
        desc: '商标注册存在驳回失败风险，中企动力利用大数据分析和先进搜索技术快速甄别类似商标注册信息及状态，帮助提高通过率。'
      }, {
        title: '服务过程担保',
        desc: '服务交易过程担保，先提供专家咨询服务，确定需求后打款，保障用户资金更加安全。'
      }, {
        title: '申报进度实时掌握',
        desc: '申请不再依靠“excel+ 纸”的方式，关键节点短信、邮件通知，申请进度第一时间知晓。'
      }, {
        title: '多种服务供您选择',
        desc: '中企动力为您提供专业服务，可一对一进行问题解答与业务建议，满足您多元的商标需求。'
      }],
      recommendList: [{
        code: '0',
        iconPath: __WEBPACK_IMPORTED_MODULE_1__static_assets_zjfd_icon_png___default.a,
        isDiscount: false,
        name: '专家辅导版',
        price: '780',
        decimal: '00',
        desc: ['专业人员全流程服务', '商标检索分析，评估成功率', '优化注册方案，全方位保护']
      }, {
        code: '1',
        iconPath: __WEBPACK_IMPORTED_MODULE_2__static_assets_dbzc_icon_png___default.a,
        name: '担保注册版',
        price: '1580',
        decimal: '00',
        desc: ['专业人员精准评估', '商标检索分析，评估成功率', '风险共担，注册失败全额退款']
      }, {
        code: '2',
        iconPath: __WEBPACK_IMPORTED_MODULE_3__static_assets_sbxz_icon_png___default.a,
        name: '商标续展',
        price: '1500',
        decimal: '00',
        desc: ['商标期满前12个月内申请', '快速提交，拒绝繁琐', '专家辅助，高性价比服务方案']
      }],
      registerStep: [{
        name: '专家评估',
        isDes: true,
        desc: '1个工作日'
      }, {
        name: '材料审核',
        isDes: true,
        desc: '1个工作日'
      }, {
        name: '提交商标局',
        isDes: true,
        desc: '1-2个月形式审查'
      }, {
        name: '受理通过',
        isDes: true,
        desc: '3-4个月实质审查'
      }, {
        name: '初审公告',
        isDes: true,
        desc: '3个月异议期'
      }, {
        name: '注册公告',
        isDes: true,
        desc: '1-2个月公告期'
      }, {
        name: '注册成功',
        isDes: false,
        desc: ''
      }],
      xzStep: [{
        name: '专家联系',
        isDes: true,
        desc: '1个工作日'
      }, {
        name: '提交续展',
        isDes: true,
        desc: '1-2个月'
      }, {
        name: '实质审查',
        isDes: true,
        desc: '3-6个月'
      }, {
        name: '续展成功',
        isDes: false,
        desc: ''
      }]
    };
  },

  components: {
    trademarkHeader: __WEBPACK_IMPORTED_MODULE_0__src_components_new_header_trademark__["a" /* default */]
  }
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_7_1_5_babel_loader_lib_index_js_node_modules_vue_loader_15_9_1_vue_loader_lib_index_js_vue_loader_options_new_header_trademark_vue_vue_type_script_lang_js___ = __webpack_require__(7);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_7_1_5_babel_loader_lib_index_js_node_modules_vue_loader_15_9_1_vue_loader_lib_index_js_vue_loader_options_new_header_trademark_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  }
});

/***/ }),
/* 8 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 9 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_7_1_5_babel_loader_lib_index_js_node_modules_vue_loader_15_9_1_vue_loader_lib_index_js_vue_loader_options_trademarkform_vue_vue_type_script_lang_js___ = __webpack_require__(11);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_7_1_5_babel_loader_lib_index_js_node_modules_vue_loader_15_9_1_vue_loader_lib_index_js_vue_loader_options_trademarkform_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_title__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_confirm_order_panel__ = __webpack_require__(52);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {

    var validatePass2 = function validatePass2(rule, value, callback) {
      var regxMobile = /^1\d{10}$/ig;
      if (value === '') {
        callback(new Error('请输入联系人手机'));
      } else if (!regxMobile.test(value)) {
        callback(new Error('请输入11位的手机号码!'));
      } else {
        callback();
      }
    };
    return {
      ruleForm: {
        productName: '',
        tradeMarkingNo: '',
        buyVersion: '1',
        remark: '',
        contactName: '',
        mobilePhone: '',
        code: ''
      },

      rules: {
        productName: [{ required: true, max: 30, message: '最多允许输入30个字符', trigger: 'blur' }],
        tradeMarkingNo: [{ required: true, max: 30, message: '最多允许输入30个字符', trigger: 'blur' }],
        buyVersion: [{
          required: true
        }],
        remark: [{
          max: 200,
          message: '请在此处对您要注册的商标做简短的描述说明，最多允许输入100个字符'
        }],
        contactName: [{
          required: true,
          message: '请输入联系人信息'
        }, {
          min: 2, max: 20, message: '请输入2~20个字符'
        }],
        mobilePhone: [{
          required: true,
          validator: validatePass2
        }, {}],
        code: [{
          required: true,
          message: '请输入短信验证码'
        }]
      },
      disabledQuery: false,
      nextButtonIsLoading: false,
      acceptAgreement: false,
      buyVersion: 'jzbb',
      domainPackageList: {
        jzbb: {
          code: '0',
          price: '336.00',
          suffix: '.com、.cn、.net',
          promotionId: '44d02891869c11e9874f005056837eb8',
          promotionName: '域名_建站必备后缀套餐',
          name: '专家辅导版',
          placeHolder: '建站必备域名含 .com、.cn、.net 三款后缀'
        },
        qypp: {
          code: '1',
          price: '2240.00',
          promotionId: '0ff3e59b869d11e9874f005056837eb8',
          promotionName: '域名_企业品牌保护套餐',
          suffix: '.网址、.中国、.企业',
          name: '担保注册版',
          placeHolder: '企业品牌保护含 .网址、.中国、.企业 三款后缀'
        },
        sbxz: {
          code: '2',
          price: '1500.00',
          promotionId: '0ff3e59b869d11e9874f005056837eb8',
          promotionName: '域名_企业品牌保护套餐',
          suffix: '.网址、.中国、.企业',
          name: '商标续展',
          placeHolder: '企业品牌保护含 .网址、.中国、.企业 三款后缀'
        }
      },
      showacceptAgreement: false,
      isSuccess: true,
      intervalNum: 60,
      validateBtnWord: '获取验证码'
    };
  },

  components: {
    cTitle: __WEBPACK_IMPORTED_MODULE_0__components_title__["a" /* default */],
    OrderPanel: __WEBPACK_IMPORTED_MODULE_1__components_confirm_order_panel__["a" /* default */]

  },
  created: function created() {
    this.ruleForm.buyVersion = this.$route.query.code;
    //强制验证登录
    this.checkLogin();
  },

  methods: {
    checkLogin: function checkLogin() {
      if (window.__PRERENDER_INJECTED && window.__PRERENDER_INJECTED.prerender === 'trademark') {
        return;
      }

      $.get(__shopURL + '/orders/checklogin?backurl=' + window.location.href).then(function (response) {});
    },
    checkAgreement: function checkAgreement() {
      this.showacceptAgreement = true;
    },
    getValidateCode: function getValidateCode() {
      var _this = this;

      this.$refs.ruleForm.validateField('mobilePhone', function (mobilePhone) {
        if (!mobilePhone) {
          _this.intervalNum = 60;
          _this.disabledQuery = true;
          var interval = setInterval(function () {
            if (_this.intervalNum < 0) {
              _this.validateBtnWord = '获取验证码';
              _this.disabledQuery = false;
              clearInterval(interval);
              _this.intervalNum = 60;
            } else {

              _this.validateBtnWord = _this.intervalNum + '\u79D2\u540E\u91CD\u65B0\u83B7\u53D6';
              _this.intervalNum = _this.intervalNum - 1;
            }
          }, 1000);

          $.get(__shopURL + '/security/shop/getSmsCode?mobileCode=' + _this.ruleForm.mobilePhone).then(function (response) {
            if (response && response.status != 101) {
              _this.$message.error(response.msg);
              clearInterval(interval);
              return;
            }
          });
        }
      });
    },
    save: function save() {
      var _this2 = this;

      // if (
      //   window.__PRERENDER_INJECTED &&
      //   window.__PRERENDER_INJECTED.prerender === 'domain'
      // ) {
      //   return
      // }
      if (!this.acceptAgreement) {
        this.$msgbox({
          // title:'',
          type: 'error',
          message: '请先同意《中企动力商标注册服务协议》'
        });
        return;
      }
      this.$refs['ruleForm'].validate(function (valid) {
        if (valid) {
          _this2.nextButtonIsLoading = true;
          if (_this2.ruleForm.buyVersion != 2) {
            delete _this2.ruleForm.tradeMarkingNo;
          } else {
            delete _this2.ruleForm.productName;
          }
          $.get(__shopURL + '/security/shop/save', _this2.ruleForm).then(function (response) {
            _this2.nextButtonIsLoading = false;
            if (response && response.status != 101) {
              _this2.$message.error(response.msg);
              return;
            }
            _this2.$router.push({
              path: '/trademark/trademark-success',
              query: {
                buyVersion: _this2.ruleForm.buyVersion
              }
            });
            _this2.isSuccess = true;
          });
        }
      });
    }
  }
});

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_7_1_5_babel_loader_lib_index_js_node_modules_vue_loader_15_9_1_vue_loader_lib_index_js_vue_loader_options_title_vue_vue_type_script_lang_js___ = __webpack_require__(13);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_7_1_5_babel_loader_lib_index_js_node_modules_vue_loader_15_9_1_vue_loader_lib_index_js_vue_loader_options_title_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['border'],
  data: function data() {
    return {
      isBorder: typeof this.border !== 'undefined'
    };
  }
});

/***/ }),
/* 14 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_7_1_5_babel_loader_lib_index_js_node_modules_vue_loader_15_9_1_vue_loader_lib_index_js_vue_loader_options_confirm_order_panel_vue_vue_type_script_lang_js___ = __webpack_require__(16);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_7_1_5_babel_loader_lib_index_js_node_modules_vue_loader_15_9_1_vue_loader_lib_index_js_vue_loader_options_confirm_order_panel_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    titleName: {
      default: ''
    }
  }
});

/***/ }),
/* 17 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 18 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_7_1_5_babel_loader_lib_index_js_node_modules_vue_loader_15_9_1_vue_loader_lib_index_js_vue_loader_options_trademarksuccess_vue_vue_type_script_lang_js___ = __webpack_require__(20);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_7_1_5_babel_loader_lib_index_js_node_modules_vue_loader_15_9_1_vue_loader_lib_index_js_vue_loader_options_trademarksuccess_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),
/* 21 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__App_vue__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_meta__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_meta___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_meta__);


Vue.use(__WEBPACK_IMPORTED_MODULE_1_vue_meta___default.a);
// const Home = require('./home').default
var ErrorPage = __webpack_require__(29).default;
var Trademark = __webpack_require__(32).default;
var RegisterTrademark = __webpack_require__(45).default;
var TrademarkSuccess = __webpack_require__(57).default;
var routes = [{
  path: '/trademark',
  component: Trademark
}, {
  path: '/trademark/trademark-form',
  component: RegisterTrademark
}, {
  path: '/trademark/trademark-success',
  component: TrademarkSuccess
}, {
  path: '/trademark/404',
  component: ErrorPage
}];

var router = new VueRouter({
  routes: routes,
  mode: 'history',
  // mode: 'hash',
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return {
        x: 0,
        y: 0
      };
    }
  }
});

new Vue({
  el: '#app',
  router: router,
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_0__App_vue__["a" /* default */]);
  },
  mounted: function mounted() {
    // You'll need this for renderAfterDocumentEvent.
    document.dispatchEvent(new Event('render-event'));
  }
});

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__App_vue_vue_type_template_id_79a250cc___ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_vue_vue_type_script_lang_js___ = __webpack_require__(1);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App_vue_vue_type_style_index_0_lang_css___ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_15_9_1_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_15_9_1_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__App_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__App_vue_vue_type_template_id_79a250cc___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__App_vue_vue_type_template_id_79a250cc___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_15_9_1_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_15_9_1_vue_loader_lib_index_js_vue_loader_options_App_vue_vue_type_template_id_79a250cc___ = __webpack_require__(25);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_15_9_1_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_15_9_1_vue_loader_lib_index_js_vue_loader_options_App_vue_vue_type_template_id_79a250cc___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_15_9_1_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_15_9_1_vue_loader_lib_index_js_vue_loader_options_App_vue_vue_type_template_id_79a250cc___["b"]; });


/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []



/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_3_0_2_extract_text_webpack_plugin_dist_loader_js_ref_0_0_node_modules_css_loader_0_28_11_css_loader_index_js_node_modules_vue_loader_15_9_1_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_2_1_6_postcss_loader_lib_index_js_node_modules_vue_loader_15_9_1_vue_loader_lib_index_js_vue_loader_options_App_vue_vue_type_style_index_0_lang_css___ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_3_0_2_extract_text_webpack_plugin_dist_loader_js_ref_0_0_node_modules_css_loader_0_28_11_css_loader_index_js_node_modules_vue_loader_15_9_1_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_2_1_6_postcss_loader_lib_index_js_node_modules_vue_loader_15_9_1_vue_loader_lib_index_js_vue_loader_options_App_vue_vue_type_style_index_0_lang_css____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_3_0_2_extract_text_webpack_plugin_dist_loader_js_ref_0_0_node_modules_css_loader_0_28_11_css_loader_index_js_node_modules_vue_loader_15_9_1_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_2_1_6_postcss_loader_lib_index_js_node_modules_vue_loader_15_9_1_vue_loader_lib_index_js_vue_loader_options_App_vue_vue_type_style_index_0_lang_css___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_3_0_2_extract_text_webpack_plugin_dist_loader_js_ref_0_0_node_modules_css_loader_0_28_11_css_loader_index_js_node_modules_vue_loader_15_9_1_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_2_1_6_postcss_loader_lib_index_js_node_modules_vue_loader_15_9_1_vue_loader_lib_index_js_vue_loader_options_App_vue_vue_type_style_index_0_lang_css____default.a); 

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * vue-meta v1.6.0
 * (c) 2019 Declan de Wet & Sébastien Chopin (@Atinux)
 * @license MIT
 */
(function (global, factory) {
	 true ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global = global || self, global.VueMeta = factory());
}(this, function () { 'use strict';

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;

	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}

		return Object(val);
	}

	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}

			// Detect buggy property enumeration order in older V8 versions.

			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}

			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}

			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}

			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}

	var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
		var arguments$1 = arguments;

		var from;
		var to = toObject(target);
		var symbols;

		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments$1[s]);

			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}

			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}

		return to;
	};

	var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

	function createCommonjsModule(fn, module) {
		return module = { exports: {} }, fn(module, module.exports), module.exports;
	}

	var umd = createCommonjsModule(function (module, exports) {
	(function (global, factory) {
		module.exports = factory();
	}(commonjsGlobal, (function () {
	var isMergeableObject = function isMergeableObject(value) {
		return isNonNullObject(value)
			&& !isSpecial(value)
	};

	function isNonNullObject(value) {
		return !!value && typeof value === 'object'
	}

	function isSpecial(value) {
		var stringValue = Object.prototype.toString.call(value);

		return stringValue === '[object RegExp]'
			|| stringValue === '[object Date]'
			|| isReactElement(value)
	}

	// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
	var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
	var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

	function isReactElement(value) {
		return value.$$typeof === REACT_ELEMENT_TYPE
	}

	function emptyTarget(val) {
		return Array.isArray(val) ? [] : {}
	}

	function cloneUnlessOtherwiseSpecified(value, options) {
		return (options.clone !== false && options.isMergeableObject(value))
			? deepmerge(emptyTarget(value), value, options)
			: value
	}

	function defaultArrayMerge(target, source, options) {
		return target.concat(source).map(function(element) {
			return cloneUnlessOtherwiseSpecified(element, options)
		})
	}

	function getMergeFunction(key, options) {
		if (!options.customMerge) {
			return deepmerge
		}
		var customMerge = options.customMerge(key);
		return typeof customMerge === 'function' ? customMerge : deepmerge
	}

	function mergeObject(target, source, options) {
		var destination = {};
		if (options.isMergeableObject(target)) {
			Object.keys(target).forEach(function(key) {
				destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
			});
		}
		Object.keys(source).forEach(function(key) {
			if (!options.isMergeableObject(source[key]) || !target[key]) {
				destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
			} else {
				destination[key] = getMergeFunction(key, options)(target[key], source[key], options);
			}
		});
		return destination
	}

	function deepmerge(target, source, options) {
		options = options || {};
		options.arrayMerge = options.arrayMerge || defaultArrayMerge;
		options.isMergeableObject = options.isMergeableObject || isMergeableObject;

		var sourceIsArray = Array.isArray(source);
		var targetIsArray = Array.isArray(target);
		var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

		if (!sourceAndTargetTypesMatch) {
			return cloneUnlessOtherwiseSpecified(source, options)
		} else if (sourceIsArray) {
			return options.arrayMerge(target, source, options)
		} else {
			return mergeObject(target, source, options)
		}
	}

	deepmerge.all = function deepmergeAll(array, options) {
		if (!Array.isArray(array)) {
			throw new Error('first argument should be an array')
		}

		return array.reduce(function(prev, next) {
			return deepmerge(prev, next, options)
		}, {})
	};

	var deepmerge_1 = deepmerge;

	return deepmerge_1;

	})));
	});

	/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */

	/** `Object#toString` result references. */
	var objectTag = '[object Object]';

	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}

	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;

	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;

	/** Used to check objects for own properties. */
	var hasOwnProperty$1 = objectProto.hasOwnProperty;

	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);

	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;

	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}

	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) ||
	      objectToString.call(value) != objectTag || isHostObject(value)) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty$1.call(proto, 'constructor') && proto.constructor;
	  return (typeof Ctor == 'function' &&
	    Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString);
	}

	var lodash_isplainobject = isPlainObject;

	/**
	 * checks if passed argument is an array
	 * @param  {any}  arr - the object to check
	 * @return {Boolean} - true if `arr` is an array
	 */
	function isArray (arr) {
	  return Array.isArray
	    ? Array.isArray(arr)
	    : Object.prototype.toString.call(arr) === '[object Array]'
	}

	function uniqBy (inputArray, predicate) {
	  return inputArray
	    .filter(function (x, i, arr) { return i === arr.length - 1
	      ? true
	      : predicate(x) !== predicate(arr[i + 1]); }
	    )
	}

	/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */

	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;

	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';

	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();

	/** Used for built-in method references. */
	var objectProto$1 = Object.prototype;

	/** Used to generate unique IDs. */
	var idCounter = 0;

	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString$1 = objectProto$1.toString;

	/** Built-in value references. */
	var Symbol$1 = root.Symbol;

	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol$1 ? Symbol$1.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;

	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike$1(value) {
	  return !!value && typeof value == 'object';
	}

	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike$1(value) && objectToString$1.call(value) == symbolTag);
	}

	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}

	/**
	 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {string} [prefix=''] The value to prefix the ID with.
	 * @returns {string} Returns the unique ID.
	 * @example
	 *
	 * _.uniqueId('contact_');
	 * // => 'contact_104'
	 *
	 * _.uniqueId();
	 * // => '105'
	 */
	function uniqueId(prefix) {
	  var id = ++idCounter;
	  return toString(prefix) + id;
	}

	var lodash_uniqueid = uniqueId;

	/**
	 * Returns the `opts.option` $option value of the given `opts.component`.
	 * If methods are encountered, they will be bound to the component context.
	 * If `opts.deep` is true, will recursively merge all child component
	 * `opts.option` $option values into the returned result.
	 *
	 * @param  {Object} opts - options
	 * @param  {Object} opts.component - Vue component to fetch option data from
	 * @param  {String} opts.option - what option to look for
	 * @param  {Boolean} opts.deep - look for data in child components as well?
	 * @param  {Function} opts.arrayMerge - how should arrays be merged?
	 * @param  {Object} [result={}] - result so far
	 * @return {Object} result - final aggregated result
	 */
	function getComponentOption (opts, result) {
	  if ( result === void 0 ) result = {};

	  var component = opts.component;
	  var option = opts.option;
	  var deep = opts.deep;
	  var arrayMerge = opts.arrayMerge;
	  var metaTemplateKeyName = opts.metaTemplateKeyName;
	  var tagIDKeyName = opts.tagIDKeyName;
	  var contentKeyName = opts.contentKeyName;
	  var $options = component.$options;

	  if (component._inactive) { return result }

	  // only collect option data if it exists
	  if (typeof $options[option] !== 'undefined' && $options[option] !== null) {
	    var data = $options[option];

	    // if option is a function, replace it with it's result
	    if (typeof data === 'function') {
	      data = data.call(component);
	    }

	    if (typeof data === 'object') {
	      // merge with existing options
	      result = umd(result, data, { arrayMerge: arrayMerge });
	    } else {
	      result = data;
	    }
	  }

	  // collect & aggregate child options if deep = true
	  if (deep && component.$children.length) {
	    component.$children.forEach(function (childComponent) {
	      result = getComponentOption({
	        component: childComponent,
	        option: option,
	        deep: deep,
	        arrayMerge: arrayMerge
	      }, result);
	    });
	  }
	  if (metaTemplateKeyName && result.hasOwnProperty('meta')) {
	    result.meta = Object.keys(result.meta).map(function (metaKey) {
	      var metaObject = result.meta[metaKey];
	      if (!metaObject.hasOwnProperty(metaTemplateKeyName) || !metaObject.hasOwnProperty(contentKeyName) || typeof metaObject[metaTemplateKeyName] === 'undefined') {
	        return result.meta[metaKey]
	      }

	      var template = metaObject[metaTemplateKeyName];
	      delete metaObject[metaTemplateKeyName];

	      if (template) {
	        metaObject.content = typeof template === 'function' ? template(metaObject.content) : template.replace(/%s/g, metaObject.content);
	      }

	      return metaObject
	    });
	    result.meta = uniqBy(
	      result.meta,
	      function (metaObject) { return metaObject.hasOwnProperty(tagIDKeyName) ? metaObject[tagIDKeyName] : lodash_uniqueid(); }
	    );
	  }
	  return result
	}

	var escapeHTML = function (str) { return typeof window === 'undefined'
	  // server-side escape sequence
	  ? String(str)
	    .replace(/&/g, '&amp;')
	    .replace(/</g, '&lt;')
	    .replace(/>/g, '&gt;')
	    .replace(/"/g, '&quot;')
	    .replace(/'/g, '&#x27;')
	  // client-side escape sequence
	  : String(str)
	    .replace(/&/g, '\u0026')
	    .replace(/</g, '\u003c')
	    .replace(/>/g, '\u003e')
	    .replace(/"/g, '\u0022')
	    .replace(/'/g, '\u0027'); };

	function _getMetaInfo (options) {
	  if ( options === void 0 ) options = {};

	  var keyName = options.keyName;
	  var tagIDKeyName = options.tagIDKeyName;
	  var metaTemplateKeyName = options.metaTemplateKeyName;
	  var contentKeyName = options.contentKeyName;
	  /**
	   * Returns the correct meta info for the given component
	   * (child components will overwrite parent meta info)
	   *
	   * @param  {Object} component - the Vue instance to get meta info from
	   * @return {Object} - returned meta info
	   */
	  return function getMetaInfo (component) {
	    // set some sane defaults
	    var defaultInfo = {
	      title: '',
	      titleChunk: '',
	      titleTemplate: '%s',
	      htmlAttrs: {},
	      bodyAttrs: {},
	      headAttrs: {},
	      meta: [],
	      base: [],
	      link: [],
	      style: [],
	      script: [],
	      noscript: [],
	      __dangerouslyDisableSanitizers: [],
	      __dangerouslyDisableSanitizersByTagID: {}
	    };

	    // collect & aggregate all metaInfo $options
	    var info = getComponentOption({
	      component: component,
	      option: keyName,
	      deep: true,
	      metaTemplateKeyName: metaTemplateKeyName,
	      tagIDKeyName: tagIDKeyName,
	      contentKeyName: contentKeyName,
	      arrayMerge: function arrayMerge (target, source) {
	        // we concat the arrays without merging objects contained in,
	        // but we check for a `vmid` property on each object in the array
	        // using an O(1) lookup associative array exploit
	        // note the use of "for in" - we are looping through arrays here, not
	        // plain objects
	        var destination = [];
	        for (var targetIndex in target) {
	          var targetItem = target[targetIndex];
	          var shared = false;
	          for (var sourceIndex in source) {
	            var sourceItem = source[sourceIndex];
	            if (targetItem[tagIDKeyName] && targetItem[tagIDKeyName] === sourceItem[tagIDKeyName]) {
	              var targetTemplate = targetItem[metaTemplateKeyName];
	              var sourceTemplate = sourceItem[metaTemplateKeyName];
	              if (targetTemplate && !sourceTemplate) {
	                sourceItem[contentKeyName] = applyTemplate(component)(targetTemplate)(sourceItem[contentKeyName]);
	              }
	              // If template defined in child but content in parent
	              if (targetTemplate && sourceTemplate && !sourceItem[contentKeyName]) {
	                sourceItem[contentKeyName] = applyTemplate(component)(sourceTemplate)(targetItem[contentKeyName]);
	                delete sourceItem[metaTemplateKeyName];
	              }
	              shared = true;
	              break
	            }
	          }

	          if (!shared) {
	            destination.push(targetItem);
	          }
	        }

	        return destination.concat(source)
	      }
	    });

	    // Remove all "template" tags from meta

	    // backup the title chunk in case user wants access to it
	    if (info.title) {
	      info.titleChunk = info.title;
	    }

	    // replace title with populated template
	    if (info.titleTemplate) {
	      info.title = applyTemplate(component)(info.titleTemplate)(info.titleChunk || '');
	    }

	    // convert base tag to an array so it can be handled the same way
	    // as the other tags
	    if (info.base) {
	      info.base = Object.keys(info.base).length ? [info.base] : [];
	    }

	    var ref = info.__dangerouslyDisableSanitizers;
	    var refByTagID = info.__dangerouslyDisableSanitizersByTagID;

	    // sanitizes potentially dangerous characters
	    var escape = function (info) { return Object.keys(info).reduce(function (escaped, key) {
	      var isDisabled = ref && ref.indexOf(key) > -1;
	      var tagID = info[tagIDKeyName];
	      if (!isDisabled && tagID) {
	        isDisabled = refByTagID && refByTagID[tagID] && refByTagID[tagID].indexOf(key) > -1;
	      }
	      var val = info[key];
	      escaped[key] = val;
	      if (key === '__dangerouslyDisableSanitizers' || key === '__dangerouslyDisableSanitizersByTagID') {
	        return escaped
	      }
	      if (!isDisabled) {
	        if (typeof val === 'string') {
	          escaped[key] = escapeHTML(val);
	        } else if (lodash_isplainobject(val)) {
	          escaped[key] = escape(val);
	        } else if (isArray(val)) {
	          escaped[key] = val.map(escape);
	        } else {
	          escaped[key] = val;
	        }
	      } else {
	        escaped[key] = val;
	      }

	      return escaped
	    }, {}); };

	    // merge with defaults
	    info = umd(defaultInfo, info);

	    // begin sanitization
	    info = escape(info);

	    return info
	  }
	}

	var applyTemplate = function (component) { return function (template) { return function (chunk) { return typeof template === 'function' ? template.call(component, chunk) : template.replace(/%s/g, chunk); }; }; };

	function _titleGenerator (options) {
	  if ( options === void 0 ) options = {};

	  var attribute = options.attribute;

	  /**
	   * Generates title output for the server
	   *
	   * @param  {'title'} type - the string "title"
	   * @param  {String} data - the title text
	   * @return {Object} - the title generator
	   */
	  return function titleGenerator (type, data) {
	    return {
	      text: function text () {
	        return String(data).trim() ? ("<" + type + " " + attribute + "=\"true\">" + data + "</" + type + ">") : ''
	      }
	    }
	  }
	}

	function _attrsGenerator (options) {
	  if ( options === void 0 ) options = {};

	  var attribute = options.attribute;

	  /**
	   * Generates tag attributes for use on the server.
	   *
	   * @param  {('bodyAttrs'|'htmlAttrs'|'headAttrs')} type - the type of attributes to generate
	   * @param  {Object} data - the attributes to generate
	   * @return {Object} - the attribute generator
	   */
	  return function attrsGenerator (type, data) {
	    return {
	      text: function text () {
	        var attributeStr = '';
	        var watchedAttrs = [];
	        for (var attr in data) {
	          if (data.hasOwnProperty(attr)) {
	            watchedAttrs.push(attr);
	            attributeStr += (typeof data[attr] !== 'undefined'
	                ? (attr + "=\"" + (data[attr]) + "\"")
	                : attr) + " ";
	          }
	        }
	        attributeStr += attribute + "=\"" + (watchedAttrs.join(',')) + "\"";
	        return attributeStr.trim()
	      }
	    }
	  }
	}

	function _tagGenerator (options) {
	  if ( options === void 0 ) options = {};

	  var attribute = options.attribute;

	  /**
	   * Generates meta, base, link, style, script, noscript tags for use on the server
	   *
	   * @param  {('meta'|'base'|'link'|'style'|'script'|'noscript')} the name of the tag
	   * @param  {(Array<Object>|Object)} tags - an array of tag objects or a single object in case of base
	   * @return {Object} - the tag generator
	   */
	  return function tagGenerator (type, tags) {
	    return {
	      text: function text (ref) {
	        if ( ref === void 0 ) ref = {};
	        var body = ref.body; if ( body === void 0 ) body = false;

	        // build a string containing all tags of this type
	        return tags.reduce(function (tagsStr, tag) {
	          if (Object.keys(tag).length === 0) { return tagsStr } // Bail on empty tag object
	          if (!!tag.body !== body) { return tagsStr }
	          // build a string containing all attributes of this tag
	          var attrs = Object.keys(tag).reduce(function (attrsStr, attr) {
	            switch (attr) {
	              // these attributes are treated as children on the tag
	              case 'innerHTML':
	              case 'cssText':
	              case 'once':
	                return attrsStr
	              // these form the attribute list for this tag
	              default:
	                if ([options.tagIDKeyName, 'body'].indexOf(attr) !== -1) {
	                  return (attrsStr + " data-" + attr + "=\"" + (tag[attr]) + "\"")
	                }
	                return typeof tag[attr] === 'undefined'
	                  ? (attrsStr + " " + attr)
	                  : (attrsStr + " " + attr + "=\"" + (tag[attr]) + "\"")
	            }
	          }, '').trim();

	          // grab child content from one of these attributes, if possible
	          var content = tag.innerHTML || tag.cssText || '';

	          // generate tag exactly without any other redundant attribute
	          var observeTag = tag.once
	            ? ''
	            : (attribute + "=\"true\" ");

	          // these tags have no end tag
	          var hasEndTag = ['base', 'meta', 'link'].indexOf(type) === -1;

	          // these tag types will have content inserted
	          var hasContent = hasEndTag && ['noscript', 'script', 'style'].indexOf(type) > -1;

	          // the final string for this specific tag
	          return !hasContent
	            ? (tagsStr + "<" + type + " " + observeTag + attrs + (hasEndTag ? '/' : '') + ">")
	            : (tagsStr + "<" + type + " " + observeTag + attrs + ">" + content + "</" + type + ">")
	        }, '')
	      }
	    }
	  }
	}

	function _generateServerInjector (options) {
	  if ( options === void 0 ) options = {};

	  /**
	   * Converts a meta info property to one that can be stringified on the server
	   *
	   * @param  {String} type - the type of data to convert
	   * @param  {(String|Object|Array<Object>)} data - the data value
	   * @return {Object} - the new injector
	   */
	  return function generateServerInjector (type, data) {
	    switch (type) {
	      case 'title':
	        return _titleGenerator(options)(type, data)
	      case 'htmlAttrs':
	      case 'bodyAttrs':
	      case 'headAttrs':
	        return _attrsGenerator(options)(type, data)
	      default:
	        return _tagGenerator(options)(type, data)
	    }
	  }
	}

	function _inject (options) {
	  if ( options === void 0 ) options = {};

	  /**
	   * Converts the state of the meta info object such that each item
	   * can be compiled to a tag string on the server
	   *
	   * @this {Object} - Vue instance - ideally the root component
	   * @return {Object} - server meta info with `toString` methods
	   */
	  return function inject () {
	    // get meta info with sensible defaults
	    var info = _getMetaInfo(options)(this.$root);

	    // generate server injectors
	    for (var key in info) {
	      if (info.hasOwnProperty(key) && key !== 'titleTemplate' && key !== 'titleChunk') {
	        info[key] = _generateServerInjector(options)(key, info[key]);
	      }
	    }

	    return info
	  }
	}

	function _updateTitle () {
	  /**
	   * Updates the document title
	   *
	   * @param  {String} title - the new title of the document
	   */
	  return function updateTitle (title) {
	    if ( title === void 0 ) title = document.title;

	    document.title = title;
	  }
	}

	function _updateTagAttributes (options) {
	  if ( options === void 0 ) options = {};

	  var attribute = options.attribute;

	  /**
	   * Updates the document's html tag attributes
	   *
	   * @param  {Object} attrs - the new document html attributes
	   * @param  {HTMLElement} tag - the HTMLElement tag to update with new attrs
	   */
	  return function updateTagAttributes (attrs, tag) {
	    var vueMetaAttrString = tag.getAttribute(attribute);
	    var vueMetaAttrs = vueMetaAttrString ? vueMetaAttrString.split(',') : [];
	    var toRemove = [].concat(vueMetaAttrs);
	    for (var attr in attrs) {
	      if (attrs.hasOwnProperty(attr)) {
	        var val = attrs[attr] || '';
	        tag.setAttribute(attr, val);
	        if (vueMetaAttrs.indexOf(attr) === -1) {
	          vueMetaAttrs.push(attr);
	        }
	        var saveIndex = toRemove.indexOf(attr);
	        if (saveIndex !== -1) {
	          toRemove.splice(saveIndex, 1);
	        }
	      }
	    }
	    var i = toRemove.length - 1;
	    for (; i >= 0; i--) {
	      tag.removeAttribute(toRemove[i]);
	    }
	    if (vueMetaAttrs.length === toRemove.length) {
	      tag.removeAttribute(attribute);
	    } else {
	      tag.setAttribute(attribute, vueMetaAttrs.join(','));
	    }
	  }
	}

	// borrow the slice method
	var toArray = Function.prototype.call.bind(Array.prototype.slice);

	function _updateTags (options) {
	  if ( options === void 0 ) options = {};

	  var attribute = options.attribute;

	  /**
	   * Updates meta tags inside <head> and <body> on the client. Borrowed from `react-helmet`:
	   * https://github.com/nfl/react-helmet/blob/004d448f8de5f823d10f838b02317521180f34da/src/Helmet.js#L195-L245
	   *
	   * @param  {('meta'|'base'|'link'|'style'|'script'|'noscript')} type - the name of the tag
	   * @param  {(Array<Object>|Object)} tags - an array of tag objects or a single object in case of base
	   * @return {Object} - a representation of what tags changed
	   */
	  return function updateTags (type, tags, headTag, bodyTag) {
	    var oldHeadTags = toArray(headTag.querySelectorAll((type + "[" + attribute + "]")));
	    var oldBodyTags = toArray(bodyTag.querySelectorAll((type + "[" + attribute + "][data-body=\"true\"]")));
	    var newTags = [];
	    var indexToDelete;

	    if (tags.length > 1) {
	      // remove duplicates that could have been found by merging tags
	      // which include a mixin with metaInfo and that mixin is used
	      // by multiple components on the same page
	      var found = [];
	      tags = tags.map(function (x) {
	        var k = JSON.stringify(x);
	        if (found.indexOf(k) < 0) {
	          found.push(k);
	          return x
	        }
	      }).filter(function (x) { return x; });
	    }

	    if (tags && tags.length) {
	      tags.forEach(function (tag) {
	        var newElement = document.createElement(type);
	        var oldTags = tag.body !== true ? oldHeadTags : oldBodyTags;

	        for (var attr in tag) {
	          if (tag.hasOwnProperty(attr)) {
	            if (attr === 'innerHTML') {
	              newElement.innerHTML = tag.innerHTML;
	            } else if (attr === 'cssText') {
	              if (newElement.styleSheet) {
	                newElement.styleSheet.cssText = tag.cssText;
	              } else {
	                newElement.appendChild(document.createTextNode(tag.cssText));
	              }
	            } else if ([options.tagIDKeyName, 'body'].indexOf(attr) !== -1) {
	              var _attr = "data-" + attr;
	              var value = (typeof tag[attr] === 'undefined') ? '' : tag[attr];
	              newElement.setAttribute(_attr, value);
	            } else {
	              var value$1 = (typeof tag[attr] === 'undefined') ? '' : tag[attr];
	              newElement.setAttribute(attr, value$1);
	            }
	          }
	        }

	        newElement.setAttribute(attribute, 'true');

	        // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	        if (oldTags.some(function (existingTag, index) {
	          indexToDelete = index;
	          return newElement.isEqualNode(existingTag)
	        })) {
	          oldTags.splice(indexToDelete, 1);
	        } else {
	          newTags.push(newElement);
	        }
	      });
	    }
	    var oldTags = oldHeadTags.concat(oldBodyTags);
	    oldTags.forEach(function (tag) { return tag.parentNode.removeChild(tag); });
	    newTags.forEach(function (tag) {
	      if (tag.getAttribute('data-body') === 'true') {
	        bodyTag.appendChild(tag);
	      } else {
	        headTag.appendChild(tag);
	      }
	    });

	    return { oldTags: oldTags, newTags: newTags }
	  }
	}

	function _updateClientMetaInfo (options) {
	  if ( options === void 0 ) options = {};

	  var ssrAttribute = options.ssrAttribute;

	  /**
	   * Performs client-side updates when new meta info is received
	   *
	   * @param  {Object} newInfo - the meta info to update to
	   */
	  return function updateClientMetaInfo (newInfo) {
	    var htmlTag = document.getElementsByTagName('html')[0];
	    // if this is not a server render, then update
	    if (htmlTag.getAttribute(ssrAttribute) === null) {
	      // initialize tracked changes
	      var addedTags = {};
	      var removedTags = {};

	      Object.keys(newInfo).forEach(function (key) {
	        switch (key) {
	          // update the title
	          case 'title':
	            _updateTitle(options)(newInfo.title);
	            break
	          // update attributes
	          case 'htmlAttrs':
	            _updateTagAttributes(options)(newInfo[key], htmlTag);
	            break
	          case 'bodyAttrs':
	            _updateTagAttributes(options)(newInfo[key], document.getElementsByTagName('body')[0]);
	            break
	          case 'headAttrs':
	            _updateTagAttributes(options)(newInfo[key], document.getElementsByTagName('head')[0]);
	            break
	          // ignore these
	          case 'titleChunk':
	          case 'titleTemplate':
	          case 'changed':
	          case '__dangerouslyDisableSanitizers':
	            break
	          // catch-all update tags
	          default:
	            var headTag = document.getElementsByTagName('head')[0];
	            var bodyTag = document.getElementsByTagName('body')[0];
	            var ref = _updateTags(options)(key, newInfo[key], headTag, bodyTag);
	        var oldTags = ref.oldTags;
	        var newTags = ref.newTags;
	            if (newTags.length) {
	              addedTags[key] = newTags;
	              removedTags[key] = oldTags;
	            }
	        }
	      });

	      // emit "event" with new info
	      if (typeof newInfo.changed === 'function') {
	        newInfo.changed.call(this, newInfo, addedTags, removedTags);
	      }
	    } else {
	      // remove the server render attribute so we can update on changes
	      htmlTag.removeAttribute(ssrAttribute);
	    }
	  }
	}

	function _refresh (options) {
	  if ( options === void 0 ) options = {};

	  /**
	   * When called, will update the current meta info with new meta info.
	   * Useful when updating meta info as the result of an asynchronous
	   * action that resolves after the initial render takes place.
	   *
	   * Credit to [Sébastien Chopin](https://github.com/Atinux) for the suggestion
	   * to implement this method.
	   *
	   * @return {Object} - new meta info
	   */
	  return function refresh () {
	    var info = _getMetaInfo(options)(this.$root);
	    _updateClientMetaInfo(options).call(this, info);
	    return info
	  }
	}

	function _$meta (options) {
	  if ( options === void 0 ) options = {};

	  /**
	   * Returns an injector for server-side rendering.
	   * @this {Object} - the Vue instance (a root component)
	   * @return {Object} - injector
	   */
	  return function $meta () {
	    return {
	      inject: _inject(options).bind(this),
	      refresh: _refresh(options).bind(this)
	    }
	  }
	}

	// fallback to timers if rAF not present
	var stopUpdate = (typeof window !== 'undefined' ? window.cancelAnimationFrame : null) || clearTimeout;
	var startUpdate = (typeof window !== 'undefined' ? window.requestAnimationFrame : null) || (function (cb) { return setTimeout(cb, 0); });

	/**
	 * Performs a batched update. Uses requestAnimationFrame to prevent
	 * calling a function too many times in quick succession.
	 * You need to pass it an ID (which can initially be `null`),
	 * but be sure to overwrite that ID with the return value of batchUpdate.
	 *
	 * @param  {(null|Number)} id - the ID of this update
	 * @param  {Function} callback - the update to perform
	 * @return {Number} id - a new ID
	 */
	function batchUpdate (id, callback) {
	  stopUpdate(id);
	  return startUpdate(function () {
	    id = null;
	    callback();
	  })
	}

	/**
	 * These are constant variables used throughout the application.
	 */

	// This is the name of the component option that contains all the information that
	// gets converted to the various meta tags & attributes for the page.
	var VUE_META_KEY_NAME = 'metaInfo';

	// This is the attribute vue-meta augments on elements to know which it should
	// manage and which it should ignore.
	var VUE_META_ATTRIBUTE = 'data-vue-meta';

	// This is the attribute that goes on the `html` tag to inform `vue-meta`
	// that the server has already generated the meta tags for the initial render.
	var VUE_META_SERVER_RENDERED_ATTRIBUTE = 'data-vue-meta-server-rendered';

	// This is the property that tells vue-meta to overwrite (instead of append)
	// an item in a tag list. For example, if you have two `meta` tag list items
	// that both have `vmid` of "description", then vue-meta will overwrite the
	// shallowest one with the deepest one.
	var VUE_META_TAG_LIST_ID_KEY_NAME = 'vmid';

	// This is the key name for possible meta templates
	var VUE_META_TEMPLATE_KEY_NAME = 'template';

	// This is the key name for the content-holding property
	var VUE_META_CONTENT_KEY = 'content';

	// automatic install
	if (typeof window !== 'undefined' && typeof window.Vue !== 'undefined') {
	  Vue.use(VueMeta);
	}

	/**
	 * Plugin install function.
	 * @param {Function} Vue - the Vue constructor.
	 */
	function VueMeta (Vue, options) {
	  if ( options === void 0 ) options = {};

	  // set some default options
	  var defaultOptions = {
	    keyName: VUE_META_KEY_NAME,
	    contentKeyName: VUE_META_CONTENT_KEY,
	    metaTemplateKeyName: VUE_META_TEMPLATE_KEY_NAME,
	    attribute: VUE_META_ATTRIBUTE,
	    ssrAttribute: VUE_META_SERVER_RENDERED_ATTRIBUTE,
	    tagIDKeyName: VUE_META_TAG_LIST_ID_KEY_NAME
	  };
	  // combine options
	  options = objectAssign(defaultOptions, options);

	  // bind the $meta method to this component instance
	  Vue.prototype.$meta = _$meta(options);

	  // store an id to keep track of DOM updates
	  var batchID = null;

	  // watch for client side component updates
	  Vue.mixin({
	    beforeCreate: function beforeCreate () {
	      // Add a marker to know if it uses metaInfo
	      // _vnode is used to know that it's attached to a real component
	      // useful if we use some mixin to add some meta tags (like nuxt-i18n)
	      if (typeof this.$options[options.keyName] !== 'undefined') {
	        this._hasMetaInfo = true;
	      }
	      // coerce function-style metaInfo to a computed prop so we can observe
	      // it on creation
	      if (typeof this.$options[options.keyName] === 'function') {
	        if (typeof this.$options.computed === 'undefined') {
	          this.$options.computed = {};
	        }
	        this.$options.computed.$metaInfo = this.$options[options.keyName];
	      }
	    },
	    created: function created () {
	      var this$1 = this;

	      // if computed $metaInfo exists, watch it for updates & trigger a refresh
	      // when it changes (i.e. automatically handle async actions that affect metaInfo)
	      // credit for this suggestion goes to [Sébastien Chopin](https://github.com/Atinux)
	      if (!this.$isServer && this.$metaInfo) {
	        this.$watch('$metaInfo', function () {
	          // batch potential DOM updates to prevent extraneous re-rendering
	          batchID = batchUpdate(batchID, function () { return this$1.$meta().refresh(); });
	        });
	      }
	    },
	    activated: function activated () {
	      var this$1 = this;

	      if (this._hasMetaInfo) {
	        // batch potential DOM updates to prevent extraneous re-rendering
	        batchID = batchUpdate(batchID, function () { return this$1.$meta().refresh(); });
	      }
	    },
	    deactivated: function deactivated () {
	      var this$1 = this;

	      if (this._hasMetaInfo) {
	        // batch potential DOM updates to prevent extraneous re-rendering
	        batchID = batchUpdate(batchID, function () { return this$1.$meta().refresh(); });
	      }
	    },
	    beforeMount: function beforeMount () {
	      var this$1 = this;

	      // batch potential DOM updates to prevent extraneous re-rendering
	      if (this._hasMetaInfo) {
	        batchID = batchUpdate(batchID, function () { return this$1.$meta().refresh(); });
	      }
	    },
	    destroyed: function destroyed () {
	      var this$1 = this;

	      // do not trigger refresh on the server side
	      if (this.$isServer) { return }
	      // re-render meta data when returning from a child component to parent
	      if (this._hasMetaInfo) {
	        // Wait that element is hidden before refreshing meta tags (to support animations)
	        var interval = setInterval(function () {
	          if (this$1.$el && this$1.$el.offsetParent !== null) { return }
	          clearInterval(interval);
	          if (!this$1.$parent) { return }
	          batchID = batchUpdate(batchID, function () { return this$1.$meta().refresh(); });
	        }, 50);
	      }
	    }
	  });
	}

	var version = "1.6.0";

	VueMeta.version = version;

	return VueMeta;

}));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28)))

/***/ }),
/* 28 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__404_vue_vue_type_template_id_a32be6bc___ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_15_9_1_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);

var script = {}


/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_15_9_1_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  script,
  __WEBPACK_IMPORTED_MODULE_0__404_vue_vue_type_template_id_a32be6bc___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__404_vue_vue_type_template_id_a32be6bc___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_15_9_1_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_15_9_1_vue_loader_lib_index_js_vue_loader_options_404_vue_vue_type_template_id_a32be6bc___ = __webpack_require__(31);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_15_9_1_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_15_9_1_vue_loader_lib_index_js_vue_loader_options_404_vue_vue_type_template_id_a32be6bc___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_15_9_1_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_15_9_1_vue_loader_lib_index_js_vue_loader_options_404_vue_vue_type_template_id_a32be6bc___["b"]; });


/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n  404\n")])}
var staticRenderFns = []



/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__trademark_vue_vue_type_template_id_4fc73260___ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__trademark_vue_vue_type_script_lang_js___ = __webpack_require__(4);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__trademark_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_15_9_1_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_15_9_1_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__trademark_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__trademark_vue_vue_type_template_id_4fc73260___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__trademark_vue_vue_type_template_id_4fc73260___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_15_9_1_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_15_9_1_vue_loader_lib_index_js_vue_loader_options_trademark_vue_vue_type_template_id_4fc73260___ = __webpack_require__(34);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_15_9_1_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_15_9_1_vue_loader_lib_index_js_vue_loader_options_trademark_vue_vue_type_template_id_4fc73260___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_15_9_1_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_15_9_1_vue_loader_lib_index_js_vue_loader_options_trademark_vue_vue_type_template_id_4fc73260___["b"]; });


/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"trademark-registration buy-cps"},[_c('trademarkHeader'),_vm._v(" "),_c('div',{staticClass:"domain-content c3"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"recommend-pro fix auto"},_vm._l((_vm.recommendList),function(item,i){return _c('div',{key:i,staticClass:"recommend-pro-item tc"},[(item.isDiscount)?_c('div',{staticClass:"isDiscount"},[_c('img',{attrs:{"src":__webpack_require__(35),"alt":""}}),_vm._v(" "),_c('span',{staticClass:"rexiao-word"},[_vm._v("热销")])]):_vm._e(),_vm._v(" "),_c('img',{attrs:{"src":item.iconPath,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"item-name mt30 f18"},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('div',{staticClass:"item-price f14 mt10"},[_c('span',{staticClass:"f18 colorJ"},[_vm._v("￥")]),_c('span',{staticClass:"f30 colorJ"},[_vm._v(_vm._s(item.price))]),_c('span',{staticClass:"f20 colorJ"},[_vm._v("."+_vm._s(item.decimal))]),_vm._v(" "),(item.code !=='2')?_c('span',[_vm._v("起")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"mt60"},_vm._l((item.desc),function(sitem,s){return _c('div',{key:s,staticClass:"mt10 recommend-desc-item lh18 auto"},[_c('img',{staticClass:"mr10",staticStyle:{"vertical-align":"text-bottom"},attrs:{"src":__webpack_require__(36),"alt":""}}),_vm._v(" "),_c('span',{staticClass:"lh18 f16"},[_vm._v(_vm._s(sitem))])])}),0),_vm._v(" "),_c('div',{staticClass:"mt40 tc mb40"},[_c('a',{staticClass:"choose-recommend-btn",attrs:{"href":("/trademark/trademark-form?code=" + (item.code))}},[_vm._v("立即注册")])])])}),0),_vm._v(" "),_c('div',{staticClass:"register-panel fix bgw"},[_c('div',{staticClass:" w1200 auto",staticStyle:{"padding-top":"70px"}},[_c('div',{staticClass:"price-register-tabs tc mb40"},[_c('div',{staticClass:"fix auto",staticStyle:{"width":"400px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.activeName),expression:"activeName"}],attrs:{"type":"radio","value":"first","id":"register","name":"register-label"},domProps:{"checked":_vm._q(_vm.activeName,"first")},on:{"change":function($event){_vm.activeName="first"}}}),_vm._v(" "),_c('label',{attrs:{"for":"register"}},[_vm._v("注册流程")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.activeName),expression:"activeName"}],attrs:{"type":"radio","value":"second","id":"price","name":"register-label"},domProps:{"checked":_vm._q(_vm.activeName,"second")},on:{"change":function($event){_vm.activeName="second"}}}),_vm._v(" "),_c('label',{attrs:{"for":"price"}},[_vm._v("资费说明")])])]),_vm._v(" "),(_vm.activeName == 'first')?_c('div',{staticClass:"mb30",staticStyle:{"position":"relative"}},[_c('div',{staticClass:"bg-line w1200"}),_vm._v(" "),_c('h2',{staticClass:"register-step-item-title"},[_vm._v("商标注册流程")]),_vm._v(" "),_vm._l((_vm.registerStep),function(item,index){return _c('div',{key:index,staticClass:"register-step-item tc"},[_c('div',{staticClass:"num-cycle tc auto"},[_vm._v(_vm._s(index+1))]),_vm._v(" "),_c('div',{staticClass:"mt20 c3 f16"},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('div',{staticClass:"mt10 c9 f12"},[_vm._v(_vm._s(item.desc))])])})],2):_vm._e(),_vm._v(" "),(_vm.activeName == 'first')?_c('div',{staticStyle:{"position":"relative"}},[_c('div',{staticClass:"bg-line w1200"}),_vm._v(" "),_c('h2',{staticClass:"register-step-item-title"},[_vm._v("商标续展流程")]),_vm._v(" "),_vm._l((_vm.xzStep),function(item,index){return _c('div',{key:index,staticClass:"register-step-item tc",class:!item.isDes?'xuzhanb':''},[_c('div',{staticClass:"num-cycle tc auto"},[_vm._v(_vm._s(index+1))]),_vm._v(" "),_c('div',{staticClass:"mt20 c3 f16"},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('div',{staticClass:"mt10 c9 f12"},[_vm._v(_vm._s(item.desc))])])})],2):_vm._e(),_vm._v(" "),(_vm.activeName == 'second')?_c('div',{staticClass:"price-table f14"},[_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_vm._m(7)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"w1200",staticStyle:{"padding-top":"90px"}},[_c('div',{staticClass:"tc f24 c3",staticStyle:{"margin-bottom":"38px"}},[_vm._v("服务优势")]),_vm._v(" "),_c('div',{staticClass:"fix pb40"},_vm._l((_vm.serverAdvantageList),function(item,r){return _c('div',{key:r,staticClass:"serverAdvantage-item fl"},[_c('div',{staticClass:"serverAdvantage-item-title"},[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('div',{staticClass:"serverAdvantage-item-desc"},[_vm._v(_vm._s(item.desc))])])}),0)])]),_vm._v(" "),_vm._m(8)])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tc section-name f24 fix"},[_c('div',{staticClass:"black-point fl"}),_vm._v(" "),_c('div',{staticClass:"fl"},[_vm._v("一站式服务")]),_vm._v(" "),_c('div',{staticClass:"black-point fl"}),_vm._v(" "),_c('div',{staticClass:"fl"},[_vm._v("最快一分钟极速申请")]),_vm._v(" "),_c('div',{staticClass:"black-point fl"}),_vm._v(" "),_c('div',{staticClass:"fl"},[_vm._v("专业人员全程指导")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row fix"},[_c('div',{staticClass:"col"},[_vm._v("注册版本")]),_vm._v(" "),_c('div',{staticClass:"col sec"},[_vm._v("专家辅导版")]),_vm._v(" "),_c('div',{staticClass:"col"},[_vm._v("担保注册版")]),_vm._v(" "),_c('div',{staticClass:"col"},[_vm._v("担保注册版")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row fix"},[_c('div',{staticClass:"col"},[_vm._v("版本定价")]),_vm._v(" "),_c('div',{staticClass:"col sec colorJ"},[_vm._v("780元起")]),_vm._v(" "),_c('div',{staticClass:"col colorJ"},[_vm._v("1580元起")]),_vm._v(" "),_c('div',{staticClass:"col colorJ"},[_vm._v("1500元")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row fix"},[_c('div',{staticClass:"col"},[_vm._v("费用构成")]),_vm._v(" "),_c('div',{staticClass:"col sec"},[_vm._v("商标局规费及中企服务费")]),_vm._v(" "),_c('div',{staticClass:"col"},[_vm._v("商标局规费及中企服务费")]),_vm._v(" "),_c('div',{staticClass:"col"},[_vm._v("商标局规费及中企服务费")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row fix"},[_c('div',{staticClass:"col",staticStyle:{"height":"70px"}},[_vm._v("商标局规费")]),_vm._v(" "),_c('div',{staticClass:"col sec"},[_c('div',[_vm._v("300元/类·件")]),_vm._v(" "),_c('div',{staticClass:"c9 mt10 f12"},[_vm._v("即：1件商标在1个类别中申请10项（含10项）以内的商品。超过10项商品，每超过1项商品加收30元。")])]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('div',[_vm._v("300元/类·件")]),_vm._v(" "),_c('div',{staticClass:"c9 mt10 f12"},[_vm._v("即：1件商标在1个类别中申请10项（含10项）以内的商品。超过10项商品，每超过1项商品加收30元。")])]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('div',[_vm._v(" "),_c('br'),_vm._v("500元/件")]),_vm._v(" "),_c('div',{staticClass:"c9 mt10 f12"},[_vm._v("  "),_c('br')])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row fix"},[_c('div',{staticClass:"col"},[_vm._v("中企服务费")]),_vm._v(" "),_c('div',{staticClass:"col sec"},[_vm._v("480元，指定项目超出10项不另外收取费用。")]),_vm._v(" "),_c('div',{staticClass:"col"},[_vm._v("1280元，指定项目超出10项不另外收取费用。")]),_vm._v(" "),_c('div',{staticClass:"col"},[_vm._v("1000元")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row fix"},[_c('div',{staticClass:"col",staticStyle:{"height":"80px"}},[_vm._v("退费条件")]),_vm._v(" "),_c('div',{staticClass:"col sec cp",staticStyle:{"height":"80px"}},[_vm._v("不退费")]),_vm._v(" "),_c('div',{staticClass:"col"},[_vm._v("商标注册申请收到商标局核发的《驳回通知书》，即：只要商标申请被商标全部驳回即可以退费。 退费流程：中企收到《驳回通知书》后，会安排管家联系申请人进行退费。")]),_vm._v(" "),_c('div',{staticClass:"col sec cp",staticStyle:{"height":"80px"}},[_vm._v("不退费")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row fix"},[_c('div',{staticClass:"col",staticStyle:{"height":"180px"}},[_vm._v("例如")]),_vm._v(" "),_c('div',{staticClass:"col sec",staticStyle:{"height":"180px"}},[_c('ul',[_c('li',[_vm._v("在1个类别中指定8项商品，费用为：商标局规费300元+中企服务费480元=780元。")]),_vm._v(" "),_c('li',[_vm._v("在1个类别中指定15项商品，费用为：商标局规费300+（15-10）×30=450元+中企服务费480元=930元。")]),_vm._v(" "),_c('li',[_vm._v("在2个类别中分别指定10项商品，费用为：商标局规费300×2=600元+中企服务费480×2元=1560元。")])])]),_vm._v(" "),_c('div',{staticClass:"col",staticStyle:{"height":"180px"}},[_c('ul',[_c('li',[_vm._v("在1个类别中指定8项商品，费用为：商标局规费300元+中企服务费1280元=1580元。")]),_vm._v(" "),_c('li',[_vm._v("若申请不成功，退还您的费用为1580元。")]),_vm._v(" "),_c('li',[_vm._v("在1个类别中指定15项商品，费用为：商标局规费300+（15-10）×30=450元+中企服务费1280元=1730元。")]),_vm._v(" "),_c('li',[_vm._v("若申请不成功，退还您的费用为1730元。")]),_vm._v(" "),_c('li',[_vm._v("在2个类别中分别指定3项商品，费用为：商标局规费300元×2+中企服务费1280元×2=3160元。")]),_vm._v(" "),_c('li',[_vm._v("若申请不成功，退还您的费用为3160元。")])])]),_vm._v(" "),_c('div',{staticClass:"col",staticStyle:{"height":"180px"}},[_vm._v("无")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w1200 common-question",staticStyle:{"padding-top":"80px","line-height":"25px"}},[_c('div',{staticClass:"tc f24 c3 mb50"},[_vm._v("常见问题")]),_vm._v(" "),_c('div',{staticClass:"f14 c9"},[_c('p',{staticClass:"question-title c3"},[_vm._v("\n          1.什么是商标？什么是注册商标？\n        ")]),_vm._v(" "),_c('p',[_c('span',[_vm._v("商标是指任何能够将自然人、法人或者其他组织的商品/服务与他人的商品/服务区别开的标志，包括文字、图形、字母、数字、三维标志、颜色组合和声音等，以及上述要素的组合。")])]),_vm._v(" "),_c('p',[_c('span',[_vm._v("注册商标是指经过商标主管机关依照法定程序及标准进行审查并通过，经《初步审定公告》无人提出异议的商标。")])]),_vm._v(" "),_c('p',[_c('br')]),_vm._v(" "),_c('p',{staticClass:"question-title c3"},[_vm._v("\n          2.商标注册有风险吗？\n        ")]),_vm._v(" "),_c('p',[_c('span',[_vm._v("商标注册存在被商标局驳回导致申请失败的风险。申请驳回失败原因可能有：受可用文字、标识资源限制，新的商标申请容易与在先申请的商标产生近似；法律法规的相关限制等。据不完全的统计，2017年我国商标申请的驳回率约50%，2018年我国商标申请的驳回率约40%。为提高商标注册成功率，申请人可在申请时提前做好应对准备。")])]),_vm._v(" "),_c('p',[_c('span'),_c('span',[_vm._v("建议：")])]),_vm._v(" "),_c('p',[_c('span',[_vm._v("　(1) 申请时将中文、英文、图形等分开申请，通过后可以组合使用，以避免因某一部分近似而被商标局整体驳回的情况，且分开申请可以根据场景灵活组合使用；")])]),_vm._v(" "),_c('p',[_c('span',[_vm._v("　(2) 准备备用方案，申请时可以在主要商标申请方案的基础上，增加一到两件备用商标，以便在主商标无法通过或全部通过的情况下，有其他可以使用的商标。")])]),_vm._v(" "),_c('p',[_c('br')]),_vm._v(" "),_c('p',{staticClass:"question-title c3"},[_vm._v("\n          3.商标申请递交多久后可以在商标网上检索到信息？\n        ")]),_vm._v(" "),_c('p',[_c('span',[_vm._v("商标申请递交商标局后，商标局会对申请进行书式审查和形式审查，通过审查后，商标局会在商标网查询系统上公开商标申请信息，公开信息包括：申请人名称，申请人地址，申请商标图样，申请时间，申请商标指定的类别和类似组群以及选择的商品/服务项目等信息。一般情况下，在商标申请递交到商标局之后的2-4周内能够查询到商标申请信息，如有补正等情况，可能会延迟一段时间，具体时间由商标局审查时间决定。")])]),_vm._v(" "),_c('p',[_c('br')]),_vm._v(" "),_c('p',{staticClass:"question-title c3"},[_vm._v("\n          4.商标注册申请需要多长时间？\n        ")]),_vm._v(" "),_c('p',[_c('span',[_vm._v("自商标递交之日起，需要经过形式审查、实质审查及初步审定公告，若商标审查顺利，无补正、驳回、异议等意外情况，按照目前的实务审查情况，12个月左右可以领取到《商标注册证》。")])]),_vm._v(" "),_c('p',[_c('span',[_vm._v("　商标审查时间主要由以下几个阶段构成：")])]),_vm._v(" "),_c('p',[_c('span',[_vm._v("　形式审查：自递交之日起1个月左右完成，审查合格后商标局核发《商标受理通知书》。")])]),_vm._v(" "),_c('p',[_c('span',[_vm._v("　实质审查：自递交之日起6个月左右完成，审核通过核发《初步审定公告通知书》，不通过或部分通过核发《驳回通知书》或《部分驳回通知书》。")])]),_vm._v(" "),_c('p',[_c('span',[_vm._v("　《初步审定公告》：公告期3个月。")])]),_vm._v(" "),_c('p',[_c('span',[_vm._v("　注册证书制证期：注册证书排版、打印、发文等工作，约2个月左右。")])]),_vm._v(" "),_c('p',[_c('br')]),_vm._v(" "),_c('p',{staticClass:"question-title c3"},[_vm._v("\n          5.什么是商标续展？\n        ")]),_vm._v(" "),_c('p',[_c('span',[_vm._v("商标续展是指商标注册人在商标注册有效期届满前12个月内或有效期届满后6个月内，依法办理一定的手续，延长其注册商标有效期的制度。期满未办理续展手续的，注销其注册商标。")])]),_vm._v(" "),_c('p',[_c('br')]),_vm._v(" "),_c('p',{staticClass:"question-title c3"},[_vm._v("\n          6.商标续展需要多久？\n        ")]),_vm._v(" "),_c('p',[_c('span',[_vm._v("完成商标续展手续会经过：商标续展注册申请、商标局审查、核发续展证明，完成整个时间大约需要4-6个月左右。")])])])])}]



/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "rexiao-icon.png?a839cca329a395b2332fe5439798f073";

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "allow-transform_03.png?7abf7a27ef111f114b31e2c324c0a89e";

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__new_header_trademark_vue_vue_type_template_id_fdcd7e38___ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__new_header_trademark_vue_vue_type_script_lang_js___ = __webpack_require__(6);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__new_header_trademark_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_15_9_1_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_15_9_1_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__new_header_trademark_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__new_header_trademark_vue_vue_type_template_id_fdcd7e38___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__new_header_trademark_vue_vue_type_template_id_fdcd7e38___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_15_9_1_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_15_9_1_vue_loader_lib_index_js_vue_loader_options_new_header_trademark_vue_vue_type_template_id_fdcd7e38___ = __webpack_require__(39);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_15_9_1_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_15_9_1_vue_loader_lib_index_js_vue_loader_options_new_header_trademark_vue_vue_type_template_id_fdcd7e38___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_15_9_1_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_15_9_1_vue_loader_lib_index_js_vue_loader_options_new_header_trademark_vue_vue_type_template_id_fdcd7e38___["b"]; });


/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-domain-banner-trademark"},[_c('div',{staticClass:"banner-img"},[_c('div',{staticClass:"link-switch fix pt30"},[_c('a',{staticClass:"fl",attrs:{"href":"/domain"}},[_vm._v("注册域名")]),_vm._v(" "),_c('a',{staticClass:"fl",attrs:{"href":"/trademark"}},[_vm._v("注册商标")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"banner-title"},[_vm._v("商标注册")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"banner-title-sub"},[_vm._v("极速申报，专业专注，全流程指导，1对1跟进，一站式服务")])])])}]



/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_3_0_2_extract_text_webpack_plugin_dist_loader_js_ref_1_0_node_modules_css_loader_0_28_11_css_loader_index_js_node_modules_vue_loader_15_9_1_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_2_1_6_postcss_loader_lib_index_js_ref_1_2_node_modules_sass_loader_7_3_1_sass_loader_dist_cjs_js_node_modules_vue_loader_15_9_1_vue_loader_lib_index_js_vue_loader_options_new_header_trademark_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_3_0_2_extract_text_webpack_plugin_dist_loader_js_ref_1_0_node_modules_css_loader_0_28_11_css_loader_index_js_node_modules_vue_loader_15_9_1_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_2_1_6_postcss_loader_lib_index_js_ref_1_2_node_modules_sass_loader_7_3_1_sass_loader_dist_cjs_js_node_modules_vue_loader_15_9_1_vue_loader_lib_index_js_vue_loader_options_new_header_trademark_vue_vue_type_style_index_0_lang_scss____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_3_0_2_extract_text_webpack_plugin_dist_loader_js_ref_1_0_node_modules_css_loader_0_28_11_css_loader_index_js_node_modules_vue_loader_15_9_1_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_2_1_6_postcss_loader_lib_index_js_ref_1_2_node_modules_sass_loader_7_3_1_sass_loader_dist_cjs_js_node_modules_vue_loader_15_9_1_vue_loader_lib_index_js_vue_loader_options_new_header_trademark_vue_vue_type_style_index_0_lang_scss___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_3_0_2_extract_text_webpack_plugin_dist_loader_js_ref_1_0_node_modules_css_loader_0_28_11_css_loader_index_js_node_modules_vue_loader_15_9_1_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_2_1_6_postcss_loader_lib_index_js_ref_1_2_node_modules_sass_loader_7_3_1_sass_loader_dist_cjs_js_node_modules_vue_loader_15_9_1_vue_loader_lib_index_js_vue_loader_options_new_header_trademark_vue_vue_type_style_index_0_lang_scss____default.a); 

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "zjfd-icon.png?ce80cf07b47be7b2bdf88051766d5196";

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "dbzc-icon.png?717c4607929efe13241bf301ac8270aa";

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "sbxz-icon.png?cd691e42070969f5424896fb57e8a339";

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_3_0_2_extract_text_webpack_plugin_dist_loader_js_ref_1_0_node_modules_css_loader_0_28_11_css_loader_index_js_node_modules_vue_loader_15_9_1_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_2_1_6_postcss_loader_lib_index_js_ref_1_2_node_modules_sass_loader_7_3_1_sass_loader_dist_cjs_js_node_modules_vue_loader_15_9_1_vue_loader_lib_index_js_vue_loader_options_trademark_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_3_0_2_extract_text_webpack_plugin_dist_loader_js_ref_1_0_node_modules_css_loader_0_28_11_css_loader_index_js_node_modules_vue_loader_15_9_1_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_2_1_6_postcss_loader_lib_index_js_ref_1_2_node_modules_sass_loader_7_3_1_sass_loader_dist_cjs_js_node_modules_vue_loader_15_9_1_vue_loader_lib_index_js_vue_loader_options_trademark_vue_vue_type_style_index_0_lang_scss____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_3_0_2_extract_text_webpack_plugin_dist_loader_js_ref_1_0_node_modules_css_loader_0_28_11_css_loader_index_js_node_modules_vue_loader_15_9_1_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_2_1_6_postcss_loader_lib_index_js_ref_1_2_node_modules_sass_loader_7_3_1_sass_loader_dist_cjs_js_node_modules_vue_loader_15_9_1_vue_loader_lib_index_js_vue_loader_options_trademark_vue_vue_type_style_index_0_lang_scss___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_3_0_2_extract_text_webpack_plugin_dist_loader_js_ref_1_0_node_modules_css_loader_0_28_11_css_loader_index_js_node_modules_vue_loader_15_9_1_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_2_1_6_postcss_loader_lib_index_js_ref_1_2_node_modules_sass_loader_7_3_1_sass_loader_dist_cjs_js_node_modules_vue_loader_15_9_1_vue_loader_lib_index_js_vue_loader_options_trademark_vue_vue_type_style_index_0_lang_scss____default.a); 

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__trademarkform_vue_vue_type_template_id_59dcd626___ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__trademarkform_vue_vue_type_script_lang_js___ = __webpack_require__(10);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__trademarkform_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_15_9_1_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_15_9_1_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__trademarkform_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__trademarkform_vue_vue_type_template_id_59dcd626___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__trademarkform_vue_vue_type_template_id_59dcd626___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_15_9_1_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_15_9_1_vue_loader_lib_index_js_vue_loader_options_trademarkform_vue_vue_type_template_id_59dcd626___ = __webpack_require__(47);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_15_9_1_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_15_9_1_vue_loader_lib_index_js_vue_loader_options_trademarkform_vue_vue_type_template_id_59dcd626___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_15_9_1_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_15_9_1_vue_loader_lib_index_js_vue_loader_options_trademarkform_vue_vue_type_template_id_59dcd626___["b"]; });


/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"buy-cps trademark-form"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"grayBg yregister",staticStyle:{"padding":"20px 0 40px"}},[_c('Order-panel',{attrs:{"titleName":"选择注册版本"}},[_c('div',_vm._l((_vm.domainPackageList),function(item){return _c('a',{attrs:{"href":"javascript:;"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ruleForm.buyVersion),expression:"ruleForm.buyVersion"}],staticClass:"label-rio",attrs:{"type":"radio","name":"label-btn","id":item.code},domProps:{"value":item.code,"checked":_vm._q(_vm.ruleForm.buyVersion,item.code)},on:{"change":function($event){return _vm.$set(_vm.ruleForm, "buyVersion", item.code)}}}),_vm._v(" "),_c('label',{staticClass:"label-name",attrs:{"for":item.code}},[_vm._v(_vm._s(item.name))])])}),0)]),_vm._v(" "),_c('Order-panel',{attrs:{"titleName":"提交商标注册信息"}},[_c('div',[_c('el-form',{ref:"ruleForm",staticClass:"demo-ruleForm",attrs:{"model":_vm.ruleForm,"rules":_vm.rules,"label-width":"100px"}},[(_vm.ruleForm.buyVersion !=2)?_c('el-form-item',{attrs:{"label":"商标名称","prop":"productName"}},[_c('div',{staticClass:"w500"},[_c('el-input',{attrs:{"placeholder":"请输入商标名称"},model:{value:(_vm.ruleForm.productName),callback:function ($$v) {_vm.$set(_vm.ruleForm, "productName", $$v)},expression:"ruleForm.productName"}})],1)]):_c('el-form-item',{attrs:{"label":"商标注册号","prop":"tradeMarkingNo"}},[_c('div',{staticClass:"w500"},[_c('el-input',{attrs:{"placeholder":"请输入商标注册号"},model:{value:(_vm.ruleForm.tradeMarkingNo),callback:function ($$v) {_vm.$set(_vm.ruleForm, "tradeMarkingNo", $$v)},expression:"ruleForm.tradeMarkingNo"}})],1)]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"说明","prop":"remark"}},[_c('div',{staticClass:"w500"},[_c('el-input',{attrs:{"type":"textarea","resize":"none","rows":2,"maxlength":"100","show-word-limit":"","placeholder":"请在此处对您要注册的商标做简短的描述说明，最多允许输入100个字符"},model:{value:(_vm.ruleForm.remark),callback:function ($$v) {_vm.$set(_vm.ruleForm, "remark", $$v)},expression:"ruleForm.remark"}})],1)]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"联系人称呼","prop":"contactName"}},[_c('div',{staticClass:"w500"},[_c('el-input',{attrs:{"placeholder":"请输入联系人"},model:{value:(_vm.ruleForm.contactName),callback:function ($$v) {_vm.$set(_vm.ruleForm, "contactName", $$v)},expression:"ruleForm.contactName"}})],1)]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"联系人手机","prop":"mobilePhone"}},[_c('div',{staticClass:"w500"},[_c('el-input',{attrs:{"placeholder":"请填写联系人手机并完成验证"},model:{value:(_vm.ruleForm.mobilePhone),callback:function ($$v) {_vm.$set(_vm.ruleForm, "mobilePhone", $$v)},expression:"ruleForm.mobilePhone"}},[_c('el-button',{attrs:{"slot":"append","disabled":_vm.disabledQuery},on:{"click":_vm.getValidateCode},slot:"append"},[_vm._v(_vm._s(_vm.validateBtnWord))])],1)],1)]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"验证码","prop":"code"}},[_c('div',{staticClass:"w500"},[_c('el-input',{attrs:{"placeholder":"请输入短信验证码"},model:{value:(_vm.ruleForm.code),callback:function ($$v) {_vm.$set(_vm.ruleForm, "code", $$v)},expression:"ruleForm.code"}})],1)])],1)],1),_vm._v(" "),_c('div',{staticClass:"register-tip"},[_c('p',{staticClass:"f12 c6"},[_vm._v("商标注册说明：")]),_vm._v(" "),_c('p',{staticClass:"f12 cb0"},[_vm._v("· 您填写商标注册申请信息后，我们会安排专业顾问在24小时内与您联系，若非工作时间内会在下一个工作日与您联系；")]),_vm._v(" "),_c('p',{staticClass:"f12 cb0"},[_vm._v("· 中企动力会保护您的商标及个人信息，仅有指定的服务商能看到您的商标及联系方式，请您放心提供；")]),_vm._v(" "),_c('p',{staticClass:"f12 cb0"},[_vm._v("· 商标服务商将会为您提供商标检索并提供成功率分析、拟定注册方案及报价以及商标提交。您可以在会员中心- 费用- 订单管理完成支付。")]),_vm._v(" "),_c('p',{staticClass:"f12 c6"},[_vm._v("商标续展流程：")]),_vm._v(" "),_c('p',{staticClass:"f12 cb0"},[_vm._v("· 商标续展费用：1500元/件；")]),_vm._v(" "),_c('p',{staticClass:"f12 cb0"},[_vm._v("· 您填写申请信息后，我们会安排专业顾问在24小时内与您联系，若非工作时间内会在下一个工作日与您联系；")]),_vm._v(" "),_c('p',{staticClass:"f12 cb0"},[_vm._v("· 专业顾问会使用区号为0592的座机与您联系，请放心接听，若您未能及时接听，专业顾问会再次与您联系；")]),_vm._v(" "),_c('p',{staticClass:"f12 cb0"},[_vm._v("· 中企动力会保护您的商标及个人信息，仅有指定的服务商能看到您的商标及联系方式，请您放心提供；")])]),_vm._v(" "),_c('div',{staticClass:"mt40"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.acceptAgreement),expression:"acceptAgreement"}],attrs:{"type":"checkbox","id":"agreement"},domProps:{"checked":Array.isArray(_vm.acceptAgreement)?_vm._i(_vm.acceptAgreement,null)>-1:(_vm.acceptAgreement)},on:{"change":function($event){var $$a=_vm.acceptAgreement,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.acceptAgreement=$$a.concat([$$v]))}else{$$i>-1&&(_vm.acceptAgreement=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.acceptAgreement=$$c}}}}),_vm._v(" "),_c('label',{attrs:{"for":"agreement"}},[_vm._v("我已阅读，理解并同意"),_c('a',{staticStyle:{"color":"#108ee9","cursor":"pointer"},on:{"click":_vm.checkAgreement}},[_vm._v("《中企动力商标注册协议》")])])])]),_vm._v(" "),_c('div',{staticClass:"total"},[_c('button',{on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v("取消")]),_vm._v(" "),_c('el-button',{class:{nextCur:_vm.acceptAgreement},staticStyle:{"padding":"0","border-radius":"0"},attrs:{"loading":_vm.nextButtonIsLoading},on:{"click":_vm.save}},[_vm._v("发送需求")])],1)],1),_vm._v(" "),_c('el-dialog',{attrs:{"visible":_vm.showacceptAgreement,"width":"50%"},on:{"update:visible":function($event){_vm.showacceptAgreement=$event}}},[_c('div',{staticStyle:{"height":"500px","overflow-y":"auto"}},[_c('p',{staticStyle:{"margin-bottom":"5px","text-align":"center"}},[_c('strong',[_c('span',{staticStyle:{"font-size":"24px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("商标服务条款")])])]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"5px","margin-right":"0","margin-bottom":"5px","margin-left":"0","text-align":"left","text-indent":"32px"}},[_c('span',{staticStyle:{"font-size":"12px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"5px","margin-right":"0","margin-bottom":"5px","margin-left":"0","text-align":"left","text-indent":"32px"}},[_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("欢迎您使用中企平台选择商标相关服务，本平台下产品和服务由中企动力及其相应关联公司（下文简称“服务方”）向您提供。")])]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"5px","margin-right":"0","margin-bottom":"5px","margin-left":"0","text-align":"left","text-indent":"32px"}},[_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("在您使用本服务前，请您务必仔细阅读本服务条款的全部内容，并在确认接受本服务条款后再进行后续操作。"),_c('strong',[_vm._v("本服务条款将通过加粗或加下划线的形式提示您特别关注限制、免责条款以及管辖法院的选择条款等。")]),_vm._v("如您不同意本服务协议或其中任何条款约定，您应不再进行下一步程序或放弃订单。")])]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"5px","margin-right":"0","margin-bottom":"5px","margin-left":"0","text-align":"left","text-indent":"32px"}},[_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"5px","margin-right":"0","margin-bottom":"5px","margin-left":"0","text-align":"left","text-indent":"32px"}},[_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("本服务条款是服务方与用户（以下简称“您”）之间，就您为您本人及/或您所代表的商标注册申请人之间，通过中企平台提供的在线商标服务（以下简称“本服务”），进行商标注册、续展等相关事宜所订立的有效合约。")])]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"5px","margin-right":"0","margin-bottom":"5px","margin-left":"0","text-align":"left","text-indent":"28px"}},[_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("当您提交商标注册、续展等相关申请，应同意接受本服务条款并平台规则及提示遵守内容时，或您通过线下签署书面协议、实际使用服务、或服务方认可且符合法律法规惯例的其他任一方式确认本服务条款后，即表示您与服务方已就本服务条款的内容达成一致意见。")])]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"5px","margin-right":"0","margin-bottom":"5px","margin-left":"0","text-align":"left"}},[_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"5px","margin-right":"0","margin-bottom":"5px","margin-left":"0","text-align":"left","text-indent":"32px"}},[_c('strong',[_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("您继续后续操作的行为，将被视为您已完全接受本服务条款的全部约定，本服务条款对服务方和您均具有法律约束力。")])])]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"5px","margin-right":"0","margin-bottom":"5px","margin-left":"0","text-align":"left","text-indent":"32px"}},[_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"5px","margin-right":"0","margin-bottom":"5px","margin-left":"24px","text-align":"left"}},[_c('strong',[_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("1.")])]),_c('span',{staticStyle:{"font-size":"9px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("    ")]),_c('strong',[_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("定义及解释")])])]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"5px","margin-right":"0","margin-bottom":"5px","margin-left":"24px","text-align":"left"}},[_c('span',{staticStyle:{"font-size":"12px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("1.1")]),_c('span',{staticStyle:{"font-size":"9px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("     ")]),_c('strong',[_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("服务方：")])]),_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("即中企动力及其相应关联公司服务方将为您的商标注册/续展事项提供平台服务与技术支持。")])]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"5px","margin-right":"0","margin-bottom":"5px","margin-left":"24px","text-align":"left"}},[_c('span',{staticStyle:{"font-size":"12px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("1.2")]),_c('span',{staticStyle:{"font-size":"9px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("     ")]),_c('strong',[_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("用户(您)：")])]),_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("是指通过服务方提供的商标服务平台，为本人或其授权委托人进行商标注册、续展等相关申请活动的会员用户，包括个人（自然人、个人独资企业、个人合伙和个体工商户等）或者组织（国家机关、公司、合伙企业、事业单位、社会团体和其他组织等）。")])]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"5px","margin-right":"0","margin-bottom":"5px","margin-left":"24px","text-align":"left"}},[_c('span',{staticStyle:{"font-size":"12px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("1.3")]),_c('span',{staticStyle:{"font-size":"9px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("     ")]),_c('strong',[_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("商标服务：")])]),_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("是指一系列通过服务方在线平台申请或提供的商标服务及增值服务。服务方有权根据业务策略适时调整平台商标服务的内容。")])]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"5px","margin-right":"0","margin-bottom":"5px","margin-left":"24px","text-align":"left"}},[_c('span',{staticStyle:{"font-size":"12px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("1.4")]),_c('span',{staticStyle:{"font-size":"9px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("     ")]),_c('strong',[_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("商标申请人：")])]),_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("是指向商标管理部门提出商标注册、续展等相关申请的主体。包括依法成立的企业、事业单位、社会团体、个体工商户、个人合伙以及符合《商标法》规定的外国人或者外国企业。商标申请人可能是用户本人，也可能是委托用户代为提交申请的其他人。"),_c('strong',[_vm._v("当商标申请人并非用户本人时，用户须取得并提交商标申请人的正式授权并提交证明文件后 ，方可使用服务方平台为商标申请人提交相关商标申请。")])])]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"auto","margin-bottom":"auto","margin-left":"24px","text-align":"left"}},[_c('span',{staticStyle:{"font-size":"12px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("1.5")]),_c('span',{staticStyle:{"font-size":"9px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("     ")]),_c('strong',[_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("第三方服务：")])]),_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("服务方平台提供的商标服务为第三方服务商的商标代理服务，本服务中的部分服务（例如：专家辅助申请服务、担保注册、商标续展申请服务等），将由第三方系统或第三方服务商为用户提供，服务方明确告知用户该等服务由第三方服务商提供，用户使用该等服务，意味着用户知悉并同意应当遵守与第三方服务商另行达成的服务协议的条款约定。")])]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"5px","margin-right":"0","margin-bottom":"5px","margin-left":"24px","text-align":"left"}},[_c('span',{staticStyle:{"font-size":"12px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("1.6")]),_c('span',{staticStyle:{"font-size":"9px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("     ")]),_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("本服务条款中的"),_c('strong',[_vm._v("“商标”")]),_vm._v("仅指中华人民共和国大陆地区的商标，不包括港澳台地区及海外。")])]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"5px","margin-right":"0","margin-bottom":"5px","margin-left":"24px","text-align":"left"}},[_c('span',{staticStyle:{"font-size":"12px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("1.7")]),_c('span',{staticStyle:{"font-size":"9px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("     ")]),_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("服务方服务过程中所涉及的本服务所有名词术语，例如：商标注册、驳回复审、异议答辩、商标续证、优先权等，均以《中华人民共和国商标法》及商标法律法规、商标行政管理部门的相关定义及解释为准。"),_c('ins',{attrs:{"datetime":"2019-07-04T14:14"}})])]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"5px","margin-right":"0","margin-bottom":"5px","margin-left":"24px","text-align":"left"}},[_c('span',{staticStyle:{"font-size":"12px","font-family":"'Tahoma','sans-serif'","color":"#333333"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"5px","margin-right":"0","margin-bottom":"5px","margin-left":"0","text-align":"left"}},[_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"5px","margin-right":"0","margin-bottom":"5px","margin-left":"24px","text-align":"left"}},[_c('strong',[_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("2.    ")])]),_c('strong',[_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("服务内容")])])]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"auto","margin-bottom":"auto","margin-left":"24px","text-align":"left"}},[_c('strong',[_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("2.1    ")])]),_c('strong',[_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("服务范围")])])]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"auto","margin-bottom":"auto","margin-left":"24px","text-align":"left"}},[_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("2.1.1    ")]),_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("服务方所称的商标服务主要包括：商标注册")])]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"5px","margin-right":"0","margin-bottom":"5px","margin-left":"48px","text-align":"left"}},[_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("2.1.1.1    ")]),_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("为商标注册服务提供所需的相应平台、通道、体系，以及与之相关的技术支持、售前售后咨询等服务。")])]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"auto","margin-bottom":"auto","margin-left":"48px","text-align":"left"}},[_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("2.1.1.2   ")]),_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("其他与商标服务相关的增值服务等。")])]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"auto","margin-bottom":"auto","text-align":"left","text-indent":"24px"}},[_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("2.1.2    ")]),_c('strong',[_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("服务方有权根据业务策略适时调整服务的范围与内容，具体以用户使用服务当时服务方相关页面的展示为准。")])])]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"16px","margin-bottom":"auto","margin-left":"24px","text-align":"left"}},[_c('strong',[_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("2.2    ")])]),_c('strong',[_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("服务开始"),_c('br')])]),_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("用户理解并确认，在用户使用本服务前已完全清楚以下要求及事项："),_c('br'),_vm._v(" 2.2.1    对于免费服务，服务方在收到用户提交的有效申请及/或确认后，才开始提供服务。例如：对于需要手机验证等方式确认用户所提交申请真实性的，服务方在用户完成验证后，才开始处理用户的请求。"),_c('strong',[_c('br')]),_vm._v("2.2.2    对于收费服务，服务方在收到用户提交的有效申请及/或确认，并且完成所有费用的缴纳后，才开始提供服务。即服务方在收到用户缴纳的费用后，才会开始处理用户申请的相关服务。"),_c('strong',[_vm._v("因此，订单支付成功并不代表相关商标的注册、续展等申请已经提交第三方服务商或商标管理部门。 ")])])]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"16px","margin-bottom":"auto","margin-left":"24px","text-align":"left"}},[_c('strong',[_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("2.3    ")])]),_c('strong',[_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("服务结果"),_c('br'),_vm._v(" 2.3.1    用户理解并同意，用户通过服务方提交的商标注册、续展等申请是否成功取决于商标标志本身及申请时间等因素，并经商标局依法审查后决定。服务方仅代为提交有关手续，除双方另有明确书面约定外，不以任何明示或者暗示的方式担保用户提交的商标注册申请或其他申请能够成功。"),_c('br')])]),_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("2.3.2    ")]),_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("服务方有权对用户提交的商标申请材料进行初步审核，如果认为内容不合法或材料不符合要求，服务方会要求用户修改或补充材料。"),_c('strong',[_vm._v("自用户完成费用支付之日起满30天时，如用户提交的材料仍不能符合提交商标局的要求，服务方有权终止本次商标服务，并将收取的相关费用退还给用户。如用户还需要继续申请注册或续展商标，需要重新购买服务。"),_c('br')]),_vm._v("2.3.3    "),_c('strong',[_vm._v("服务方提供的商标服务均为单次服务")]),_vm._v("。"),_c('strong',[_vm._v("例如：如果用户对商标局驳回决定不服的，选择提起驳回复审；或者在用户的商标初审公告之日起3个月内被异议后，选择提出异议答辩的；或者用户需要对已注册的商标改变其标志的，用户均应另行购买相应的服务方申请服务，重新提交申请并另行付费。")])])]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"16px","margin-bottom":"auto","margin-left":"24px","text-align":"left"}},[_c('strong',[_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("2.4    ")])]),_c('strong',[_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("商标注册服务"),_c('br')])]),_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("2.4.1    ")]),_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("用户可以在通过服务方或关联公司平台选择购买 “商标担保版”、“商标顾问版”两种类型的商标注册服务。"),_c('br'),_vm._v(" 2.4.2    服务方不会对用户的商标注册申请是否侵犯他人在先权利，或他人拟申请注册的商标是否侵犯用户的在先权利等进行审核，用户自行承担责任。"),_c('br'),_vm._v(" 2.4.3    在用户提交的商标注册申请尚未提交至商标局前，用户可以选择申请退款，终止本次申请的商标服务。"),_c('strong',[_vm._v("商标注册申请提交至商标局后，不论商标是否注册成功，已收取的费用都不予退还。")]),_vm._v("商标注册申请是否提交至商标局，以服务方/第三方服务商后台数据为准。")])]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"16px","margin-bottom":"auto","margin-left":"24px","text-align":"left"}},[_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("2.4.4        ")]),_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("在购买“商标担保版”后，商标注册被全部驳回，视为担保失败，可以全额退款。“部分驳回”或者有“项目初审公告”，则视 为担保成功，不予退款。")])]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"5px","margin-right":"0","margin-bottom":"5px","margin-left":"24px","text-align":"left"}},[_c('strong',[_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("3.")])]),_c('span',{staticStyle:{"font-size":"9px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("    ")]),_c('strong',[_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("服务费用")])])]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"5px","margin-right":"0","margin-bottom":"5px","margin-left":"24px","text-align":"left"}},[_c('span',{staticStyle:{"font-size":"12px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("3.1")]),_c('span',{staticStyle:{"font-size":"9px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("     ")]),_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("用户理解并同意，服务方将根据用户选择的商标服务的类型和数量收取对应的服务费用，服务费用的收取方式为系统自动结算。")])]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"5px","margin-right":"0","margin-bottom":"5px","margin-left":"24px","text-align":"left"}},[_c('strong',[_c('span',{staticStyle:{"font-size":"12px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("3.2")])]),_c('strong',[_c('span',{staticStyle:{"font-size":"9px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("   ")])]),_c('strong',[_c('span',{staticStyle:{"font-size":"9px","font-family":"'微软雅黑','sans-serif'","color":"red"}},[_vm._v("  ")])]),_c('strong',[_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"red"}},[_vm._v("服务方将在网站（www.300.cn）")])]),_c('strong',[_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("的相关网页/平台公示有关收费标准和缴费要求，并有权根据业务需要和市场变化等原因，调整上述标准和要求；或者根据当时的市场状况及自身经营政策等因素，制定不同的服务收费标准、优惠与促销政策等。本服务协议约定相关服务价格及退款规则等条款内容与上述服务方平台公告不一致的，以服务方平台/网页公告内容为准。")])])]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"5px","margin-right":"0","margin-bottom":"5px","margin-left":"24px","text-align":"left"}},[_c('strong',[_c('span',{staticStyle:{"font-size":"12px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("3.3")])]),_c('span',{staticStyle:{"font-size":"9px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("  ")]),_c('strong',[_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("若用户对服务方提供的收费标准、费用结算事项的通知内容有异议，应及时以书面形式告知服务方，并停止使用本服务；否则，视为用户认可服务方提供的费用结算事项的通知内容，双方应按照服务方提供的费用结算事项的通知内容，进行费用的结算及支付等。")])])]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"auto","margin-bottom":"auto","margin-left":"24px","text-align":"left"}},[_c('span',{staticStyle:{"font-size":"12px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("3.4")]),_c('span',{staticStyle:{"font-size":"9px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("     ")]),_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("服务方会定期或不定期推出优惠活动或政策。用户理解并确认：")])]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"auto","margin-bottom":"auto","margin-left":"48px","text-align":"left"}},[_c('span',{staticStyle:{"font-size":"12px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("3.4.1")]),_c('span',{staticStyle:{"font-size":"10px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("    ")]),_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("此类优惠活动或政策均为服务方在正常服务价格之外的特别优惠；服务方不保证用户一定可以享受该等特别优惠。")])]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"auto","margin-bottom":"auto","margin-left":"48px","text-align":"left"}},[_c('span',{staticStyle:{"font-size":"12px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("3.4.2")]),_c('span',{staticStyle:{"font-size":"10px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("    ")]),_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("用户在通过参与优惠活动或享受优惠政策而购买了服务方商标服务后，又在规定的退订时间内进行服务退订的，则服务方有权采取恢复原价计费、收取违约金或收取退订/退款手续费、补偿免费代金券抵扣金额等方式进行处理，具体以服务方在相应页面、订单或活动规则中载明的方式为准。")])]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"auto","margin-bottom":"auto","margin-left":"48px","text-align":"left"}},[_c('span',{staticStyle:{"font-size":"12px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("3.4.3")]),_c('span',{staticStyle:{"font-size":"10px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("    ")]),_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("除非服务方以书面形式给予明确说明，通常情况下，多种优惠不可同时叠加适用。")])]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"auto","margin-bottom":"auto","margin-left":"24px","text-align":"left"}},[_c('span',{staticStyle:{"font-size":"12px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("3.5")]),_c('span',{staticStyle:{"font-size":"9px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("     ")]),_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("用户理解并认可，服务方可能在一定期间或一定使用额度内为用户提供优惠活动：")])]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"auto","margin-bottom":"auto","margin-left":"48px","text-align":"left"}},[_c('span',{staticStyle:{"font-size":"12px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("3.5.1")]),_c('span',{staticStyle:{"font-size":"10px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("     ")]),_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("在优惠活动期间内，用户可享受一定额度的服务费用的折扣优惠。")])]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"auto","margin-bottom":"auto","margin-left":"48px","text-align":"left"}},[_c('span',{staticStyle:{"font-size":"12px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("3.5.2")]),_c('span',{staticStyle:{"font-size":"9px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("     ")]),_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("服务方并不排除日后取消该等优惠服务活动的可能，届时服务方将提前10个自然日通过在网站内合适版面发布公告或发送站内通知等方式公布收费政策及规范；")])]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"auto","margin-bottom":"auto","margin-left":"48px","text-align":"left"}},[_c('span',{staticStyle:{"font-size":"12px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("3.5.3")]),_c('span',{staticStyle:{"font-size":"10px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("    ")]),_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("如用户仍使用相应服务的，用户应按届时最新的收费政策付费。")])]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"auto","margin-bottom":"auto","margin-left":"48px","text-align":"left"}},[_c('strong',[_c('span',{staticStyle:{"font-size":"12px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("3.5.4   ")])]),_c('span',{staticStyle:{"font-size":"9px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v(" ")]),_c('strong',[_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("用户同意，因收费标准调整等产生的任何纠纷，除法律有明确规定外，服务方有免于诉讼或仲裁的权利。")])])]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"5px","margin-right":"0","margin-bottom":"5px","margin-left":"0","text-align":"left"}},[_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"5px","margin-right":"0","margin-bottom":"5px","margin-left":"24px","text-align":"left"}},[_c('strong',[_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("4.")])]),_c('span',{staticStyle:{"font-size":"9px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("    ")]),_c('strong',[_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("用户行为准则")])])]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"5px","margin-right":"0","margin-bottom":"5px","margin-left":"24px","text-align":"left"}},[_c('span',{staticStyle:{"font-size":"12px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("4.1")]),_c('span',{staticStyle:{"font-size":"9px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("     ")]),_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("用户在确认本服务条款并使用商标注册服务前，应保证：")])]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"auto","margin-bottom":"auto","margin-left":"48px","text-align":"left"}},[_c('strong',[_c('span',{staticStyle:{"font-size":"12px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("4.1.1")])]),_c('span',{staticStyle:{"font-size":"9px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("       ")]),_c('strong',[_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("用户已认真阅读并充分理解本服务条款的所有内容及服务方在平台相关页面公布的商标服务规则；用户应当遵守本服务条款及服务方商标服务规则的所有已公示并生效的规定，不能以未仔细阅读规则或规则理解偏差为由，作为用户不遵守规则、违约的理由。")])])]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"auto","margin-bottom":"auto","margin-left":"48px","text-align":"left"}},[_c('strong',[_c('span',{staticStyle:{"font-size":"12px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("4.1.2")])]),_c('span',{staticStyle:{"font-size":"9px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("       ")]),_c('strong',[_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("如用户是代表第三方注册，用户应确保已获得该第三方的全部合法授权，且该第三方已理解并同意遵守前述所有义务。此外，如果用户提供的注册信息及资料中包括第三方的信息及使用，用户应确保已经告知并获得该第三方的同意。")])])]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"auto","margin-bottom":"auto","margin-left":"48px","text-align":"left"}},[_c('span',{staticStyle:{"font-size":"12px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("4.1.3")]),_c('span',{staticStyle:{"font-size":"10px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("    ")]),_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("如果用户在未取得商标注册证之前已经使用该未注册商标，用户应注意在广告、产品等方面的适量投入，且不得随意更改商标样式；否则有可能会影响用户的商标注册申请成功率。")])]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"5px","margin-right":"0","margin-bottom":"5px","margin-left":"24px","text-align":"left"}},[_c('span',{staticStyle:{"font-size":"12px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("4.2")]),_c('span',{staticStyle:{"font-size":"9px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("     ")]),_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("用户应了解并保证：")])]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"auto","margin-bottom":"auto","margin-left":"48px","text-align":"left"}},[_c('span',{staticStyle:{"font-size":"12px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("4.2.1")]),_c('span',{staticStyle:{"font-size":"10px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("    ")]),_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("用户所提交的商标申请信息及材料应当真实、准确、完整、合法"),_c('strong',[_vm._v("，若因提交的信息或材料不准确而影响商标申请及商标注册后的权利使用，用户需自行承担责任及后果")]),_vm._v("。")])]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"5px","margin-right":"0","margin-bottom":"5px","margin-left":"48px","text-align":"left"}},[_c('strong',[_c('span',{staticStyle:{"font-size":"12px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("4.2.2")])]),_c('strong',[_c('span',{staticStyle:{"font-size":"10px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("    ")])]),_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("用户在提交相关商标申请时应提供完整，准确，可靠的联系人详细信息，且该等信息在商标申请审核期间如有变更的，用户应及时予以更正和更新"),_c('strong',[_vm._v("。如因联系方式提供错误或未更新导致信息传达延误，用户需自行承担责任及后果。")])])]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"5px","margin-right":"0","margin-bottom":"5px","margin-left":"48px","text-align":"left"}},[_c('strong',[_c('span',{staticStyle:{"font-size":"12px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("4.2.3")])]),_c('strong',[_c('span',{staticStyle:{"font-size":"10px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("    ")])]),_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("用户应积极配合，对于商标局要求在规定时间内给予反馈的通知文件，用户应在规定时间内反馈意见或提交所需材料。"),_c('strong',[_vm._v("如因用户未及时反馈信息或提供所需材料，用户需自行承担责任及后果。")])])]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"5px","margin-right":"0","margin-bottom":"5px","margin-left":"48px","text-align":"left"}},[_c('strong',[_c('span',{staticStyle:{"font-size":"12px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("4.2.4")])]),_c('span',{staticStyle:{"font-size":"10px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("    ")]),_c('strong',[_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("如果用户并非为本人提交申请，而是接受商标申请人的委托，代为提交相关商标申请的，除符合规范的申请文件外，还应当提交商标申请人的相关主体资格证明、委托授权书等相关材料；如申请过程中商标申请人的名称、地址发生变化的，用户应及时更新委托文件，以免影响商标申请的受理及申请信息的准确及正确。")])])]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"auto","margin-bottom":"auto","margin-left":"24px","text-align":"left"}},[_c('span',{staticStyle:{"font-size":"12px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("4.3")]),_c('span',{staticStyle:{"font-size":"9px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("     ")]),_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("用户应了解并保证，")])]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"5px","margin-right":"0","margin-bottom":"5px","margin-left":"48px","text-align":"left"}},[_c('strong',[_c('span',{staticStyle:{"font-size":"12px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("4.3.1")])]),_c('strong',[_c('span',{staticStyle:{"font-size":"10px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("    ")])]),_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("用户提交相关商标申请的请求内容及相关申请材料，均不会侵害任意第三方的权益，亦不存在违法违规情形，用户的商标申请不是为了恶意或任何非法目的。"),_c('strong',[_vm._v("如有故意抢注或刻意模仿他人商标或其他侵犯他人知识产权的行为，用户需自行承担责任及后果。")])])]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"5px","margin-right":"0","margin-bottom":"5px","margin-left":"48px","text-align":"left"}},[_c('span',{staticStyle:{"font-size":"12px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("4.3.2   ")]),_c('span',{staticStyle:{"font-size":"9px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v(" ")]),_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("如用户因申请或使用此商标而引起的任何纠纷或损失，与服务方无关。同时，用户有义务保护服务方免于受到任何因用户申请或使用此商标而引起的第三方诉讼、索赔或其他行为而造成的损害。")])]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"5px","margin-right":"0","margin-bottom":"5px","margin-left":"48px","text-align":"left"}},[_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"5px","margin-right":"0","margin-bottom":"5px","margin-left":"24px","text-align":"left"}},[_c('strong',[_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("5.")])]),_c('span',{staticStyle:{"font-size":"9px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("    ")]),_c('strong',[_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("服务方服务承诺")])])]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"5px","margin-right":"0","margin-bottom":"5px","margin-left":"24px","text-align":"left"}},[_c('span',{staticStyle:{"font-size":"12px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("5.1")]),_c('span',{staticStyle:{"font-size":"9px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("     ")]),_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("服务方在接受用户的委托，代理用户向商标局申请相关商标事项后，将在用户的委托事项和委托范围内开展工作，不会随意更改商标代理事项。用户应按照要求向服务商提供合法有效明确的授权等。")])]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"auto","margin-bottom":"auto","margin-left":"24px","text-align":"left"}},[_c('span',{staticStyle:{"font-size":"12px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("5.2")]),_c('span',{staticStyle:{"font-size":"9px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("     ")]),_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("服务方在用户提交符合要求的全部文件资料后，服务方将及时向第三方服务商或商标局提交用户的商标申请。但如果服务方进行初步审核后，认为用户的申请内容不合法或申请材料不符合要求的，服务方有权要求用户修改或补正材料。在用户未按要求进行修改或补正前，服务方不会向商标局提交用户的商标申请并不承担任何责任。")])]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"5px","margin-right":"0","margin-bottom":"5px","margin-left":"24px","text-align":"left"}},[_c('span',{staticStyle:{"font-size":"12px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("5.3")]),_c('span',{staticStyle:{"font-size":"9px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("    "),_c('strong',[_vm._v(" ")])]),_c('strong',[_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("如用户特别授权服务方代收相关文件资料的，服务方将会在收到商标局的相关文件后15个工作日内，将原件寄至用户在服务方平台系统中预留的收件地址，请用户再次确认在服务平台中的收件地址是正确的、有效的地址，因用户收件地址填写错误，造成用户未收到相关文件的后果由用户自行承担，与服务方无关")])]),_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("。")])]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"5px","margin-right":"0","margin-bottom":"5px","margin-left":"24px","text-align":"left"}},[_c('span',{staticStyle:{"font-size":"12px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("5.4")]),_c('span',{staticStyle:{"font-size":"9px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("     ")]),_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("服务方将采取安全保密措施保护用户提交的商标申请信息及材料。对于在服务过程中涉及用户及/或商标申请人的商业信息、知识产权信息或个人信息，未经用户同意，服务方不会泄露给与本服务无关的任何第三方，不得用于本合同外的目的。")])]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"5px","margin-right":"0","margin-bottom":"5px","margin-left":"0","text-align":"left"}},[_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"5px","margin-right":"0","margin-bottom":"5px","margin-left":"24px","text-align":"left"}},[_c('strong',[_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("6.")])]),_c('span',{staticStyle:{"font-size":"9px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("    ")]),_c('strong',[_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("不可抗力及责任承担")])])]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"5px","margin-right":"0","margin-bottom":"5px","margin-left":"24px","text-align":"left"}},[_c('span',{staticStyle:{"font-size":"12px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("6.1")]),_c('span',{staticStyle:{"font-size":"9px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("     ")]),_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("因不可抗力或者其他意外事件，使得本服务履行不可能、不必要或者无意义的，遭受不可抗力、意外事件的一方不承担责任。“不可抗力、意外事件”是指不能预见、不能克服并不能避免且对一方或双方当事人造成重大影响的客观事件，包括但不限于自然灾害如洪水、地震、瘟疫流行等以及社会事件如战争、动乱、政府行为、电信主干线路中断等。")])]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"5px","margin-right":"0","margin-bottom":"5px","margin-left":"24px","text-align":"left"}},[_c('span',{staticStyle:{"font-size":"12px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("6.2")]),_c('span',{staticStyle:{"font-size":"9px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("     ")]),_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("鉴于互联网的特殊性，黑客攻击"),_c('strong',[_vm._v("、互联网连通中断或者系统故障、电信部门原因造成的连通中断等非服务方原因给用户造成的损失，除另有生效法律文书规定外，服务方不承担责任。")])])]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"5px","margin-right":"0","margin-bottom":"5px","margin-left":"24px","text-align":"left"}},[_c('strong',[_c('span',{staticStyle:{"font-size":"12px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("6.3")])]),_c('strong',[_c('span',{staticStyle:{"font-size":"9px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("     ")])]),_c('strong',[_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("若因服务方的过错导致用户商标申请失败，服务方的责任上限为该笔申请费用。服务方不对用户的其他直接或间接损失、商机的消失、利润的损失、侵权、其他无形损失及基于用户与他人签署的合同而遭受的损失承担责任。")])])]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"5px","margin-right":"0","margin-bottom":"5px","margin-left":"24px","text-align":"left"}},[_c('span',{staticStyle:{"font-size":"12px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("6.4")]),_c('span',{staticStyle:{"font-size":"9px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("     ")]),_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("用户应承担违反本服务条款而给服务方造成的损失。服务方未对违约采取措施不能成为用户违约或者抗辩的理由和解释。")])]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"5px","margin-right":"0","margin-bottom":"5px","margin-left":"24px","text-align":"left"}},[_c('span',{staticStyle:{"font-size":"12px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("6.5")]),_c('span',{staticStyle:{"font-size":"9px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("     ")]),_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("本服务条款对责任承担另有规定的，从其规定。")])]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"5px","margin-right":"0","margin-bottom":"5px","margin-left":"24px","text-align":"left"}},[_c('strong',[_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("7.")])]),_c('span',{staticStyle:{"font-size":"9px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("    ")]),_c('strong',[_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("适用法律与争议解决")])])]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"5px","margin-right":"0","margin-bottom":"5px","margin-left":"24px","text-align":"left"}},[_c('span',{staticStyle:{"font-size":"12px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("7.1")]),_c('span',{staticStyle:{"font-size":"9px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("     ")]),_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("本服务条款的订立、执行和解释及争议的解决均应适用中华人民共和国法律。")])]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"5px","margin-right":"0","margin-bottom":"5px","margin-left":"24px","text-align":"left"}},[_c('span',{staticStyle:{"font-size":"12px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("7.2")]),_c('span',{staticStyle:{"font-size":"9px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("     ")]),_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("用户理解并同意，用户与服务方之间就服务方为用户提供的商标的服务而引发争议时，"),_c('strong',[_vm._v("双方当事人应通过友好协商方式解决。")])]),_c('span',{staticStyle:{"font-size":"9px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v(" ")]),_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("如果协商未成，双方同意向服务方主要经营地的有管辖权的人民法院提起诉讼。")])]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"5px","margin-right":"0","margin-bottom":"5px","margin-left":"0","text-align":"left","text-indent":"32px"}},[_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"5px","margin-right":"0","margin-bottom":"5px","margin-left":"24px","text-align":"left"}},[_c('strong',[_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("8.")])]),_c('span',{staticStyle:{"font-size":"9px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("    ")]),_c('strong',[_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("其他")])])]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"5px","margin-right":"0","margin-bottom":"5px","margin-left":"24px","text-align":"left"}},[_c('span',{staticStyle:{"font-size":"12px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("8.1")]),_c('span',{staticStyle:{"font-size":"9px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("     ")]),_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("本服务条款如果与双方以前签署的有关条款或者服务方的有关陈述不一致或者相抵触的，以本服务条款为准。")])]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"5px","margin-right":"0","margin-bottom":"5px","margin-left":"24px","text-align":"left"}},[_c('strong',[_c('span',{staticStyle:{"font-size":"12px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("8.2")])]),_c('span',{staticStyle:{"font-size":"9px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("  ")]),_c('strong',[_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("用户与服务方就商标服务达成的服务协议，除以上服务条款主文以外，还应包括服务方在相关页面上的服务说明、价格说明、操作文档和用户确认同意的订购页面、订单信息等，该等内容均为本服务条款不可分割的一部分。此外，服务方将来可能发布并采取合理途径通知的、与本服务相关各类规则，亦为本服务条款的一部分，具有同等法律效力。鉴于网络协议的特殊展现形式，以上内容共同构成完整有效的合同文件，对服务方与用户均具有法律约束力。")])])]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"auto","margin-bottom":"auto","margin-left":"24px","text-align":"left"}},[_c('span',{staticStyle:{"font-size":"12px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("8.3")]),_c('span',{staticStyle:{"font-size":"9px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("     ")]),_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("本服务条款项下之保证条款、保密条款、知识产权条款、法律适用及争议解决条款等内容，不因服务的终止而失效。")])]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"5px","margin-right":"0","margin-bottom":"5px","margin-left":"0","text-align":"left","text-indent":"28px"}},[_c('strong',[_c('span',{staticStyle:{"font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v("您在此再次保证，已经完全阅读并理解了上述商标服务条款并自愿正式进入商标注册服务流程，接受上述条款的约束。")])])]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"5px","margin-right":"0","margin-bottom":"5px","margin-left":"0","text-align":"left"}},[_c('span',{staticStyle:{"font-size":"12px","font-family":"'微软雅黑','sans-serif'","color":"#333333"}},[_vm._v(" ")])]),_vm._v(" "),_c('p',[_c('br')])])]),_vm._v(" "),_c('input',{staticClass:"log_id",attrs:{"type":"hidden","name":"log_id","value":""}}),_vm._v(" "),_c('input',{staticClass:"promoteSlug",attrs:{"type":"hidden","name":"promoteSlug","value":""}}),_vm._v(" "),_c('input',{staticClass:"channelSlug",attrs:{"type":"hidden","name":"channelSlug","value":""}}),_vm._v(" "),_c('input',{staticClass:"formSlug",attrs:{"type":"hidden","name":"formSlug","value":""}}),_vm._v(" "),_c('input',{staticClass:"landUrl",attrs:{"type":"hidden","name":"landUrl","value":""}}),_vm._v(" "),_c('input',{staticClass:"sourceUrl",attrs:{"type":"hidden","name":"sourceUrl","value":""}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"eventType","value":"ywpt-sbzc"}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"formType","value":"业务品台商标注册"}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"baiduSource","value":"brandreg"}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"DgrayBg yregister"},[_c('div',{staticClass:"w1200 flow"},[_c('h2',[_vm._v("选择商品配置")]),_vm._v(" "),_c('ul',[_c('li',[_c('i',{staticClass:"step"},[_vm._v("1")]),_vm._v("添加清单")]),_vm._v(" "),_c('li',[_c('i',{staticClass:"step"},[_vm._v("2")]),_vm._v("确认订单")]),_vm._v(" "),_c('li',[_c('i',[_vm._v("3")]),_vm._v("在线支付")]),_vm._v(" "),_c('li',[_c('i',[_vm._v("4")]),_vm._v("支付成功")])])])])}]



/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__title_vue_vue_type_template_id_d88f6372_scoped_true___ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__title_vue_vue_type_script_lang_js___ = __webpack_require__(12);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__title_vue_vue_type_style_index_0_id_d88f6372_scoped_true_lang_scss___ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_15_9_1_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_15_9_1_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__title_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__title_vue_vue_type_template_id_d88f6372_scoped_true___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__title_vue_vue_type_template_id_d88f6372_scoped_true___["b" /* staticRenderFns */],
  false,
  null,
  "d88f6372",
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_15_9_1_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_15_9_1_vue_loader_lib_index_js_vue_loader_options_title_vue_vue_type_template_id_d88f6372_scoped_true___ = __webpack_require__(50);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_15_9_1_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_15_9_1_vue_loader_lib_index_js_vue_loader_options_title_vue_vue_type_template_id_d88f6372_scoped_true___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_15_9_1_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_15_9_1_vue_loader_lib_index_js_vue_loader_options_title_vue_vue_type_template_id_d88f6372_scoped_true___["b"]; });


/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title",class:{'is-border':_vm.isBorder}},[_c('h2',{staticClass:"title-inner"},[_vm._t("default")],2)])}
var staticRenderFns = []



/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_3_0_2_extract_text_webpack_plugin_dist_loader_js_ref_1_0_node_modules_css_loader_0_28_11_css_loader_index_js_node_modules_vue_loader_15_9_1_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_2_1_6_postcss_loader_lib_index_js_ref_1_2_node_modules_sass_loader_7_3_1_sass_loader_dist_cjs_js_node_modules_vue_loader_15_9_1_vue_loader_lib_index_js_vue_loader_options_title_vue_vue_type_style_index_0_id_d88f6372_scoped_true_lang_scss___ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_3_0_2_extract_text_webpack_plugin_dist_loader_js_ref_1_0_node_modules_css_loader_0_28_11_css_loader_index_js_node_modules_vue_loader_15_9_1_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_2_1_6_postcss_loader_lib_index_js_ref_1_2_node_modules_sass_loader_7_3_1_sass_loader_dist_cjs_js_node_modules_vue_loader_15_9_1_vue_loader_lib_index_js_vue_loader_options_title_vue_vue_type_style_index_0_id_d88f6372_scoped_true_lang_scss____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_3_0_2_extract_text_webpack_plugin_dist_loader_js_ref_1_0_node_modules_css_loader_0_28_11_css_loader_index_js_node_modules_vue_loader_15_9_1_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_2_1_6_postcss_loader_lib_index_js_ref_1_2_node_modules_sass_loader_7_3_1_sass_loader_dist_cjs_js_node_modules_vue_loader_15_9_1_vue_loader_lib_index_js_vue_loader_options_title_vue_vue_type_style_index_0_id_d88f6372_scoped_true_lang_scss___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_3_0_2_extract_text_webpack_plugin_dist_loader_js_ref_1_0_node_modules_css_loader_0_28_11_css_loader_index_js_node_modules_vue_loader_15_9_1_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_2_1_6_postcss_loader_lib_index_js_ref_1_2_node_modules_sass_loader_7_3_1_sass_loader_dist_cjs_js_node_modules_vue_loader_15_9_1_vue_loader_lib_index_js_vue_loader_options_title_vue_vue_type_style_index_0_id_d88f6372_scoped_true_lang_scss____default.a); 

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__confirm_order_panel_vue_vue_type_template_id_8e7c0c9a___ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__confirm_order_panel_vue_vue_type_script_lang_js___ = __webpack_require__(15);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__confirm_order_panel_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_15_9_1_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_15_9_1_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__confirm_order_panel_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__confirm_order_panel_vue_vue_type_template_id_8e7c0c9a___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__confirm_order_panel_vue_vue_type_template_id_8e7c0c9a___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_15_9_1_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_15_9_1_vue_loader_lib_index_js_vue_loader_options_confirm_order_panel_vue_vue_type_template_id_8e7c0c9a___ = __webpack_require__(54);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_15_9_1_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_15_9_1_vue_loader_lib_index_js_vue_loader_options_confirm_order_panel_vue_vue_type_template_id_8e7c0c9a___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_15_9_1_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_15_9_1_vue_loader_lib_index_js_vue_loader_options_confirm_order_panel_vue_vue_type_template_id_8e7c0c9a___["b"]; });


/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w1200 auto confirm-order-panel"},[_c('div',{staticClass:"confirm-order-title"},[_vm._v(_vm._s(_vm.titleName))]),_vm._v(" "),_c('div',{staticClass:"confirm-order-body"},[_vm._t("default")],2)])}
var staticRenderFns = []



/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_3_0_2_extract_text_webpack_plugin_dist_loader_js_ref_1_0_node_modules_css_loader_0_28_11_css_loader_index_js_node_modules_vue_loader_15_9_1_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_2_1_6_postcss_loader_lib_index_js_ref_1_2_node_modules_sass_loader_7_3_1_sass_loader_dist_cjs_js_node_modules_vue_loader_15_9_1_vue_loader_lib_index_js_vue_loader_options_confirm_order_panel_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_3_0_2_extract_text_webpack_plugin_dist_loader_js_ref_1_0_node_modules_css_loader_0_28_11_css_loader_index_js_node_modules_vue_loader_15_9_1_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_2_1_6_postcss_loader_lib_index_js_ref_1_2_node_modules_sass_loader_7_3_1_sass_loader_dist_cjs_js_node_modules_vue_loader_15_9_1_vue_loader_lib_index_js_vue_loader_options_confirm_order_panel_vue_vue_type_style_index_0_lang_scss____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_3_0_2_extract_text_webpack_plugin_dist_loader_js_ref_1_0_node_modules_css_loader_0_28_11_css_loader_index_js_node_modules_vue_loader_15_9_1_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_2_1_6_postcss_loader_lib_index_js_ref_1_2_node_modules_sass_loader_7_3_1_sass_loader_dist_cjs_js_node_modules_vue_loader_15_9_1_vue_loader_lib_index_js_vue_loader_options_confirm_order_panel_vue_vue_type_style_index_0_lang_scss___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_3_0_2_extract_text_webpack_plugin_dist_loader_js_ref_1_0_node_modules_css_loader_0_28_11_css_loader_index_js_node_modules_vue_loader_15_9_1_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_2_1_6_postcss_loader_lib_index_js_ref_1_2_node_modules_sass_loader_7_3_1_sass_loader_dist_cjs_js_node_modules_vue_loader_15_9_1_vue_loader_lib_index_js_vue_loader_options_confirm_order_panel_vue_vue_type_style_index_0_lang_scss____default.a); 

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_3_0_2_extract_text_webpack_plugin_dist_loader_js_ref_1_0_node_modules_css_loader_0_28_11_css_loader_index_js_node_modules_vue_loader_15_9_1_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_2_1_6_postcss_loader_lib_index_js_ref_1_2_node_modules_sass_loader_7_3_1_sass_loader_dist_cjs_js_node_modules_vue_loader_15_9_1_vue_loader_lib_index_js_vue_loader_options_trademarkform_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_3_0_2_extract_text_webpack_plugin_dist_loader_js_ref_1_0_node_modules_css_loader_0_28_11_css_loader_index_js_node_modules_vue_loader_15_9_1_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_2_1_6_postcss_loader_lib_index_js_ref_1_2_node_modules_sass_loader_7_3_1_sass_loader_dist_cjs_js_node_modules_vue_loader_15_9_1_vue_loader_lib_index_js_vue_loader_options_trademarkform_vue_vue_type_style_index_0_lang_scss____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_3_0_2_extract_text_webpack_plugin_dist_loader_js_ref_1_0_node_modules_css_loader_0_28_11_css_loader_index_js_node_modules_vue_loader_15_9_1_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_2_1_6_postcss_loader_lib_index_js_ref_1_2_node_modules_sass_loader_7_3_1_sass_loader_dist_cjs_js_node_modules_vue_loader_15_9_1_vue_loader_lib_index_js_vue_loader_options_trademarkform_vue_vue_type_style_index_0_lang_scss___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_3_0_2_extract_text_webpack_plugin_dist_loader_js_ref_1_0_node_modules_css_loader_0_28_11_css_loader_index_js_node_modules_vue_loader_15_9_1_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_2_1_6_postcss_loader_lib_index_js_ref_1_2_node_modules_sass_loader_7_3_1_sass_loader_dist_cjs_js_node_modules_vue_loader_15_9_1_vue_loader_lib_index_js_vue_loader_options_trademarkform_vue_vue_type_style_index_0_lang_scss____default.a); 

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__trademarksuccess_vue_vue_type_template_id_70f5e12c___ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__trademarksuccess_vue_vue_type_script_lang_js___ = __webpack_require__(19);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__trademarksuccess_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_15_9_1_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(0);






/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_3__node_modules_vue_loader_15_9_1_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__trademarksuccess_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__trademarksuccess_vue_vue_type_template_id_70f5e12c___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__trademarksuccess_vue_vue_type_template_id_70f5e12c___["b" /* staticRenderFns */],
  false,
  null,
  null,
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_15_9_1_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_15_9_1_vue_loader_lib_index_js_vue_loader_options_trademarksuccess_vue_vue_type_template_id_70f5e12c___ = __webpack_require__(59);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_15_9_1_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_15_9_1_vue_loader_lib_index_js_vue_loader_options_trademarksuccess_vue_vue_type_template_id_70f5e12c___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_15_9_1_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_15_9_1_vue_loader_lib_index_js_vue_loader_options_trademarksuccess_vue_vue_type_template_id_70f5e12c___["b"]; });


/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"trademark-success"},[_c('div',{staticClass:"success-panel w1200 auto pt100"},[_c('div',{staticClass:"tc "},[_c('span',{staticStyle:{"color":"#525252"}},[_vm._v("需求类型：")]),_c('span',{staticStyle:{"color":"#1fb09f"}},[_vm._v(_vm._s(_vm.$route.query.buyVersion=='1'?'担保注册版':_vm.$route.query.buyVersion=='2'?'商标续展':'专家辅导版'))]),_vm._v("   \n        "),_c('span',{staticStyle:{"color":"#525252"}},[_vm._v("预期价格：")]),_c('span',{staticStyle:{"color":"#999999"}},[_vm._v("2000元以下")])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('p',{staticClass:"tc f18",staticStyle:{"color":"#333333"}},[_vm._v("您的"+_vm._s(_vm.$route.query.buyVersion=='1'?'担保注册版':_vm.$route.query.buyVersion=='2'?'商标续展':'专家辅导版')+"需求发布成功！")]),_vm._v(" "),_c('p',{staticClass:"tc f12 mt10",staticStyle:{"color":"#999"}},[_vm._v("1-2个工作日内服务商会与您联络，请保持电话畅通")]),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"DgrayBg yregister"},[_c('div',{staticClass:"w1200 flow"},[_c('h2',[_vm._v("选择商品配置")]),_vm._v(" "),_c('ul',[_c('li',[_c('i',{staticClass:"step"},[_vm._v("1")]),_vm._v("添加清单")]),_vm._v(" "),_c('li',[_c('i',{staticClass:"step"},[_vm._v("2")]),_vm._v("确认订单")]),_vm._v(" "),_c('li',[_c('i',[_vm._v("3")]),_vm._v("在线支付")]),_vm._v(" "),_c('li',[_c('i',[_vm._v("4")]),_vm._v("支付成功")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tc",staticStyle:{"margin-top":"45px","margin-bottom":"40px"}},[_c('img',{attrs:{"src":__webpack_require__(60),"alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"\n       tc",staticStyle:{"margin-top":"32px"}},[_c('a',{staticClass:"i-know",attrs:{"href":"/trademark"}},[_vm._v("知道了")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auto success-tip"},[_c('div',{staticStyle:{"padding":"36px"}},[_c('p',{staticClass:"f14",staticStyle:{"color":"#666666"}},[_vm._v("服务商后续注册流程需要您提供以下资料，请提前准备。")]),_vm._v(" "),_c('p',{staticClass:"f12",staticStyle:{"color":"#999999","margin-top":"25px"}},[_c('span',{staticStyle:{"color":"#666666"}},[_vm._v("个人：")]),_vm._v("申请人身份证正反面照片、个体工商户营业执照照片、委托书、委托书模板复用法律声明")]),_vm._v(" "),_c('p',{staticClass:"f12",staticStyle:{"color":"#999999","margin-top":"13px"}},[_c('span',{staticStyle:{"color":"#666666"}},[_vm._v("企业：")]),_vm._v("申请企业营业执照副本复印件、委托书、委托书模板复用法律声明")])])])}]



/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "apply-success-icon.png?60b2a73257f62b48ae3a20eb57818fcb";

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_3_0_2_extract_text_webpack_plugin_dist_loader_js_ref_1_0_node_modules_css_loader_0_28_11_css_loader_index_js_node_modules_vue_loader_15_9_1_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_2_1_6_postcss_loader_lib_index_js_ref_1_2_node_modules_sass_loader_7_3_1_sass_loader_dist_cjs_js_node_modules_vue_loader_15_9_1_vue_loader_lib_index_js_vue_loader_options_trademarksuccess_vue_vue_type_style_index_0_lang_scss___ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_3_0_2_extract_text_webpack_plugin_dist_loader_js_ref_1_0_node_modules_css_loader_0_28_11_css_loader_index_js_node_modules_vue_loader_15_9_1_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_2_1_6_postcss_loader_lib_index_js_ref_1_2_node_modules_sass_loader_7_3_1_sass_loader_dist_cjs_js_node_modules_vue_loader_15_9_1_vue_loader_lib_index_js_vue_loader_options_trademarksuccess_vue_vue_type_style_index_0_lang_scss____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_3_0_2_extract_text_webpack_plugin_dist_loader_js_ref_1_0_node_modules_css_loader_0_28_11_css_loader_index_js_node_modules_vue_loader_15_9_1_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_2_1_6_postcss_loader_lib_index_js_ref_1_2_node_modules_sass_loader_7_3_1_sass_loader_dist_cjs_js_node_modules_vue_loader_15_9_1_vue_loader_lib_index_js_vue_loader_options_trademarksuccess_vue_vue_type_style_index_0_lang_scss___);
/* unused harmony reexport namespace */
 /* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__node_modules_extract_text_webpack_plugin_3_0_2_extract_text_webpack_plugin_dist_loader_js_ref_1_0_node_modules_css_loader_0_28_11_css_loader_index_js_node_modules_vue_loader_15_9_1_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_2_1_6_postcss_loader_lib_index_js_ref_1_2_node_modules_sass_loader_7_3_1_sass_loader_dist_cjs_js_node_modules_vue_loader_15_9_1_vue_loader_lib_index_js_vue_loader_options_trademarksuccess_vue_vue_type_style_index_0_lang_scss____default.a); 

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// build.js